/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Address {
  address?: string;
  city?: string;
  index?: string;
  country?: string;
  name?: string;
}

/** Модель части адреса */
export interface AddressItemDto {
  /**
   * ID
   * @format int64
   */
  id?: number;
  name?: string;
  /**
   * @minLength 0
   * @maxLength 64
   */
  prefix?: string;
  /** Тип геолокации */
  itemType?: "DISTRICT" | "REGION" | "CITY" | "STREET";
}

export interface Balance {
  /** @format date */
  date?: string;
  /** @format double */
  balanceBegin?: number;
  /** @format double */
  balanceEnd?: number;
  /** @format double */
  credit?: number;
  /** @format double */
  debit?: number;
  /** @format int32 */
  creditAuthorizations?: number;
  /** @format int32 */
  debitAuthorizations?: number;
  /** @format int32 */
  operationsCount?: number;
  balances?: Balance[];
}

export interface BrigadeGroupDto {
  /**
   * id
   * @format uuid
   */
  id?: string;
  name?: string;
  description?: string;
  /** @format uuid */
  leaderUid: string;
  /** @format uuid */
  managerUid: string;
  accounts?: UserAccountDto[];
  predefined?: boolean;
  workerGroup?: boolean;
  active?: boolean;
}

/** Модель смены пароля пользователя */
export interface ChangedPasswordRecord {
  /**
   * Uid пользователя, пароль которого модифицируется
   * @format uuid
   */
  uid?: string;
  /**
   * Пока не обязательно
   * @deprecated
   */
  oldPassword?: string;
  /** Новый или временный пароль (регулируется флагом 'isTemporary') */
  newPassword?: string;
  /**
   * Должен ли пользователь обновить свой пароль при следующем входе?<br>(для Менеджеров - всегда true)
   * @default "true"
   */
  isTemporary?: boolean;
}

export interface CompanyDto {
  /**
   * id
   * @format uuid
   */
  id?: string;
  /** Компания или Контрактор */
  partyType?: "COMPANY" | "PERSON" | "CONTRACTOR";
  /** Полное название компании */
  fullCompanyName: string;
  /** ИНН компании */
  inn: string;
  /** ОГРН компании */
  ogrn?: string;
  /** КПП компании */
  kpp?: string;
  /** Описание компании */
  description?: string;
  /** Веб-сайт компании */
  website?: string;
  /** Электронная почта компании */
  email?: string;
  /** Телефон(ы) компании */
  phone?: string;
  /** Владелец компании */
  leader?: UserAccountDto;
  /** ФИО владельца (VF) */
  leaderFIO?: string;
  /** Юридический адрес */
  address?: FullAddressDto;
  /** Способ расчётa (через банк) */
  payment?: PaymentDto;
  /** Текущий тариф компании */
  tariff?: CompanyTariffShortRecord;
  /** Текущий баланс Компании */
  balance?: number;
  /**
   * Связь компании с контактным лицом (или другой компанией)
   * @uniqueItems true
   */
  relations: PartyPartyRelDto[];
  /**
   * Список внутренних контрактов
   * @uniqueItems true
   */
  innerContracts?: InnerContractDto[];
}

export interface CompanyTariffShortRecord {
  title?: string;
  /** @format date-time */
  tariffEndDate?: string;
  /** @format int64 */
  diskSpace?: number;
  /** @format int64 */
  usedDiskSpace?: number;
  period?: string;
  /** Статус тарифа компании */
  status?: "WAITING" | "FROZEN" | "CLOSED" | "ACTIVE";
}

export interface Contact {
  /** @example "angelicalis39@mail.ru" */
  email?: string;
}

/** Модель контракта */
export interface ContractDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format int64
   */
  id?: number;
  /**
   * Порядковый номер (для отображения на фронте)
   * @format int64
   */
  counter?: number;
  /**
   * Компания, заключившая контракт
   * @format uuid
   */
  companyId: string;
  /** Название компании, заключившей контракт */
  companyName?: string;
  /** Описание */
  description?: string;
  /** Тип услуг данного контракта */
  serviceType: ServiceTypesDictDto;
  /** Текущий статус */
  statusCode?: "IMPORTING" | "IMPORTED" | "PROCESSING" | "CREATED" | "DONE";
  /**
   * Дата начала контракта
   * @format date-time
   */
  startDate?: string;
  /**
   * Дата истечения контракта
   * @format date-time
   */
  dueDate?: string;
  /** Идентификатор по договору */
  contractNumber?: string;
  /**
   * Наименование исполнителя по контракту
   * @minLength 0
   * @maxLength 127
   */
  executor?: string;
  /**
   * Менеджеры, имеющие доступ к данному контракту
   * @uniqueItems true
   */
  managers?: UserAccountDto[];
  archived?: boolean;
}

/** Модель места проведения работ */
export interface ContractLocationsDictDto {
  /** ID */
  code?: string;
  name?: string;
  /** Описание */
  description?: string;
  /** @format int32 */
  sortOrder?: number;
  /**
   * Дата удаления
   * @format date-time
   */
  deletedDate?: string;
  id?: string;
  /** @uniqueItems true */
  aliases?: string[];
}

export interface CounterParty {
  account?: string;
  bankBic?: string;
  bankName?: string;
  bankSwiftCode?: string;
  corrAccount?: string;
  inn?: string;
  kpp?: string;
  name?: string;
}

export interface DashboardContractData {
  contract?: DashboardContractShortDto;
  serviceRequests?: DashboardDetails[];
}

export interface DashboardContractShortDto {
  /**
   * ID
   * @format int64
   */
  id?: number;
  /**
   * Компания, заключившая контракт
   * @format uuid
   */
  companyId: string;
  /** Название компаниии, заключившей контракт */
  companyName?: string;
  /** Описание */
  description?: string;
  /** Текущий статус */
  statusCode?: "IMPORTING" | "IMPORTED" | "PROCESSING" | "CREATED" | "DONE";
  /**
   * Дата начала контракта
   * @format date-time
   */
  startDate?: string;
  /**
   * Дата истечения контракта
   * @format date-time
   */
  dueDate?: string;
  /** Идентификатор по договору */
  contractNumber?: string;
  /**
   * Порядковый номер (для отображения на фронте)
   * @format int64
   */
  counter?: number;
  archived?: boolean;
}

export interface DashboardDetails {
  /** @format int64 */
  srId?: number;
  /** @format date-time */
  plannedDate?: string;
  lastStatus?: string;
  /** @format date-time */
  lastStatusDate?: string;
  /** @format int64 */
  leadTime?: number;
  /** @uniqueItems true */
  statuses?: string[];
}

/** Модель главной страницы веб (дашборд) */
export interface DashboardDto {
  serviceType?: string;
  totals?: Totals;
  contracts?: DashboardContractData[];
}

/** Модель главной страницы веб (дашборд) */
export interface DashboardDtoPaged {
  companyName?: string;
  contractNumber?: string;
  /** @format date-time */
  contractStartDate?: string;
  serviceType?: string;
  serviceRequests?: SRDetails[];
}

/** Модель обновленного устройства */
export interface DeviceDictionaryDto {
  /**
   * id в БД
   * @format int64
   */
  id?: number;
  /**
   * Компания, имающая доступ к оборудованию (работающая с ним)
   * @format uuid
   */
  companyId: string;
  /** Заводской номер */
  serial: string;
  /** Оператор (сим-карты или типа того) */
  operator?: string;
  /** ICC сим-карты */
  simIcc?: string;
  /** IP-адрес */
  ip?: string;
  /** Модель */
  model: DeviceModelDto;
  /**
   * Год производства
   * @format int32
   */
  createdYear?: number;
  /**
   * Дата поверки
   * @format date-time
   */
  verificationDate?: string;
  /**
   * Показания Т1
   * @format int32
   */
  t1?: number;
  /**
   * Показания Т2
   * @format int32
   */
  t2?: number;
  /**
   * Показания Т3
   * @format int32
   */
  t3?: number;
  /** Номер пломбы */
  sealNumber?: string;
  /** Текущий статус и состояние оборудования, дополнительное описание */
  deviceStatus: DeviceStatusDto;
  /**
   * К какой заявке привязано уст-во
   * @format int64
   */
  serviceRequestId?: number;
}

/** Модель оборудования для справочника устройств */
export interface DeviceModelDto {
  /**
   * id модели оборудования в БД
   * @format int64
   */
  id?: number;
  /** Название модели оборудования */
  model: string;
  /**
   * Фазность оборудования, если есть
   * @format int32
   */
  fazesCount: number;
  /**
   * Тарифность оборудования, если есть
   * @format int32
   */
  tariffsCount: number;
  /**
   * Межпроверочный интервал (лет)
   * @format int32
   */
  years: number;
  /**
   * Разрядность
   * @format int32
   */
  digitCapacity: number;
  /**
   * Класс точности
   * @format int32
   */
  accuracyClass: number;
}

export interface DeviceStatusDto {
  /**
   * ID
   * @format int64
   */
  id?: number;
  /** Текущий статус оборудования */
  status: "UNKNOWN" | "FREE" | "BROKEN" | "RETIREMENT" | "ISSUED" | "INSTALLED";
  /** Причина изменения статуса */
  reasonStatusChanged: string;
  /** Комментарий по желанию */
  comment?: string;
  /**
   * UID менеджера, вносящего изменения
   * @format uuid
   */
  managerUid: string;
  /**
   * UID работника, взаимодействующего с оборудованием
   * @format uuid
   */
  workerUid: string;
  moderationNeeds?: boolean;
}

export interface DocumentDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format uuid
   */
  id?: string;
  /**
   * Путь к файлу
   * @example "/documents/doc.txt"
   */
  path: {
    /** @format int32 */
    nameCount?: number;
    fileSystem?: {
      rootDirectories?: object;
      fileStores?: object;
      userPrincipalLookupService?: object;
      separator?: string;
      readOnly?: boolean;
      open?: boolean;
    };
    fileName?: {
      /** @format int32 */
      nameCount?: number;
      fileSystem?: {
        rootDirectories?: object;
        fileStores?: object;
        userPrincipalLookupService?: object;
        separator?: string;
        readOnly?: boolean;
        open?: boolean;
      };
      absolute?: boolean;
    };
    absolute?: boolean;
    parent?: {
      /** @format int32 */
      nameCount?: number;
      fileSystem?: {
        rootDirectories?: object;
        fileStores?: object;
        userPrincipalLookupService?: object;
        separator?: string;
        readOnly?: boolean;
        open?: boolean;
      };
      absolute?: boolean;
    };
    root?: {
      /** @format int32 */
      nameCount?: number;
      fileSystem?: {
        rootDirectories?: object;
        fileStores?: object;
        userPrincipalLookupService?: object;
        separator?: string;
        readOnly?: boolean;
        open?: boolean;
      };
      absolute?: boolean;
    };
  };
  /**
   * @minLength 0
   * @maxLength 256
   */
  mimeType?: string;
  /**
   * Описание документа, указанное при загрузке
   * @example "Мой новый отчёт за июль"
   */
  description: string;
  fileName?: string;
  /** @format int64 */
  fileSize?: number;
  /** @format int64 */
  srId?: number;
  /**
   * ФИО загрузившего
   * @example "Пользователь, загрузивший данный файл в систему"
   */
  createdFio?: string;
  /**
   * Широта
   * @example "Широта локации сделанного фото"
   */
  latitude?: string;
  /**
   * Долгота
   * @example "ПДолгота локации сделанного фото"
   */
  longitude?: string;
  /** @format uuid */
  offlineReqId?: string;
  /** Тип документа */
  docTypeCode?:
    | "SERVICE_REQUESTS"
    | "DICTIONARY_UPDATE"
    | "STATUS_APPROVED_UPDATE"
    | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
    | "SERVICE_REQUESTS_REASON_DELAY_DOC"
    | "OUT_REPORT"
    | "SERVICE_REQUESTS_PHOTO"
    | "OTHER";
}

/** Набор фильтров */
export interface FiltersSetDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 64
   * @example "Мои заявки"
   */
  name: string;
  /** @format uuid */
  userUid: string;
  filterType: string;
  /**
   * Список фильтров в виде JSON (поля и значения)
   * @minLength 0
   * @maxLength 512
   */
  filters: string;
}

/** Примерная модель искомого адреса */
export interface FullAddressDto {
  /** @format uuid */
  id?: string;
  /** Почтовый код */
  postalCode?: string;
  /** Регион */
  region?: AddressItemDto;
  /** Район */
  district?: AddressItemDto;
  /** Населённый пункт */
  city?: AddressItemDto;
  /** Улица */
  street?: AddressItemDto;
  /** Дом */
  house?: string;
  /** Строение */
  building?: string;
  /** Квартира */
  apartment?: string;
  /** Кадастровый номер */
  cadastre?: string;
  /** Широта */
  latitude?: string;
  /** Долгота */
  longitude?: string;
  /** Полный адрес в виде строки */
  fullAddress?: string;
  /** @format date-time */
  createdDate?: string;
  checked?: boolean;
}

/** Модель импорта */
export interface ImportDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id в БД
   * @format uuid
   */
  id?: string;
  /**
   * uid инициатора импорта
   * @format uuid
   */
  initiatorUid?: string;
  initiator?: UserAccountDto;
  /**
   * Компания
   * @format uuid
   */
  companyId: string;
  /** Комментарий */
  comment?: string;
  /** Статус парсинга импорта (excel) */
  statusCode?:
    | "WAITING_FOR_START"
    | "PROCESSING"
    | "FINISHED_SUCCESSFULLY"
    | "FINISHED_WITH_ERRORS"
    | "REJECTED";
  /** @format uuid */
  sourceDocumentId?: string;
  sourceDocument?: DocumentDto;
  /** @format date-time */
  importStartDate?: string;
  /** @format date-time */
  importFinishDate?: string;
  /** @format int32 */
  totalRowCount?: number;
  /** @format int32 */
  successRowCount?: number;
  /** @format int32 */
  updateRowCount?: number;
  /** @format int32 */
  addRowCount?: number;
  /** @format int32 */
  skipRowCount?: number;
  /** @format int32 */
  failedRowCount?: number;
  /** @format uuid */
  errorDocumentId?: string;
  errorDocument?: DocumentDto;
  /** Тип услуги */
  serviceType?: ServiceTypesDictDto;
  /**
   * Контракт
   * @format int64
   */
  taskId?: number;
}

export interface InnerContractDto {
  /** @format uuid */
  id?: string;
  /** Номер внутреннего договора компании */
  innerNumber?: string;
  /**
   * Дата начала действия договора
   * @format date-time
   */
  startDate?: string;
  /**
   * Дата окончания действия договора
   * @format date-time
   */
  endDate?: string;
  active?: boolean;
}

export interface Item {
  /** @example "Рога" */
  name: string;
  /**
   * @format int64
   * @example 1
   */
  amount?: number;
  /**
   * @format int64
   * @example 50000
   */
  price?: number;
  /** @example "Шт" */
  unit?: string;
  /** @example "None | 5 | 10 | 15" */
  vat?: string;
}

export type JsonNode = object;

export interface LeadTimes {
  /** @format int64 */
  max?: number;
  /** @format int64 */
  average?: number;
  /** @format int64 */
  min?: number;
}

export interface Operation {
  /** @format date-time */
  operationDate?: string;
  /** @format uuid */
  operationId?: string;
  operationStatus?: string;
  accountNumber?: string;
  bic?: string;
  typeOfOperation?: string;
  category?: string;
  /** @format date-time */
  trxnPostDate?: string;
  /** @format date-time */
  authorizationDate?: string;
  /** @format date-time */
  drawDate?: string;
  /** @format date-time */
  chargeDate?: string;
  /** @format date-time */
  docDate?: string;
  documentNumber?: string;
  payVo?: string;
  vo?: string;
  /** @format int32 */
  priority?: number;
  /** @format double */
  operationAmount?: number;
  /** @format int32 */
  operationCurrencyDigitalCode?: number;
  /** @format double */
  accountAmount?: number;
  /** @format int32 */
  accountCurrencyDigitalCode?: number;
  /** @format double */
  rubleAmount?: number;
  description?: string;
  payPurpose?: string;
  cardNumber?: string;
  /** @format int32 */
  ucid?: number;
  mcc?: string;
  authCode?: string;
  rrn?: string;
  acquirerId?: string;
  payer?: Participant;
  receiver?: Participant;
  counterParty?: CounterParty;
  merch?: Address;
  tax?: Tax;
}

export interface PageAddressItemDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: AddressItemDto[];
  empty?: boolean;
}

export interface PageBrigadeGroupDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: BrigadeGroupDto[];
  empty?: boolean;
}

export interface PageCompanyDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: CompanyDto[];
  empty?: boolean;
}

export interface PageContractDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ContractDto[];
  empty?: boolean;
}

export interface PageContractLocationsDictDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ContractLocationsDictDto[];
  empty?: boolean;
}

export interface PageDashboardDtoPaged {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: DashboardDtoPaged[];
  empty?: boolean;
}

export interface PageDeviceDictionaryDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: DeviceDictionaryDto[];
  empty?: boolean;
}

export interface PageDeviceModelDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: DeviceModelDto[];
  empty?: boolean;
}

export interface PageDocumentDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: DocumentDto[];
  empty?: boolean;
}

export interface PageFiltersSetDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: FiltersSetDto[];
  empty?: boolean;
}

export interface PageImportDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ImportDto[];
  empty?: boolean;
}

export interface PagePartyPartyRelDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: PartyPartyRelDto[];
  empty?: boolean;
}

export interface PagePaymentDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: PaymentDto[];
  empty?: boolean;
}

export interface PageReasonRejectionDictDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ReasonRejectionDictDto[];
  empty?: boolean;
}

export interface PageServiceRequestDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ServiceRequestDto[];
  empty?: boolean;
}

export interface PageServiceRequestShortDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ServiceRequestShortDto[];
  empty?: boolean;
}

export interface PageServiceTypesDictDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: ServiceTypesDictDto[];
  empty?: boolean;
}

export interface PageTbankSendResponseDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: TbankSendResponseDto[];
  empty?: boolean;
}

export interface PageUserAccountDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: UserAccountDto[];
  empty?: boolean;
}

export interface PageWorkContentDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: WorkContentDto[];
  empty?: boolean;
}

export interface PageWorkStageDto {
  /** @format int64 */
  totalElements?: number;
  /** @format int32 */
  totalPages?: number;
  pageable?: PageableObject;
  sort?: SortObject;
  /** @format int32 */
  numberOfElements?: number;
  first?: boolean;
  last?: boolean;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  size?: number;
  content?: WorkStageDto[];
  empty?: boolean;
}

export interface Pageable {
  /**
   * @format int32
   * @min 0
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   */
  size?: number;
  sort?: string[];
}

export interface PageableObject {
  paged?: boolean;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  unpaged?: boolean;
  sort?: SortObject;
  /** @format int64 */
  offset?: number;
}

export interface Participant {
  acct?: string;
  name?: string;
  inn?: string;
  kpp?: string;
  bicRu?: string;
  bicSwift?: string;
  bankName?: string;
  corAcct?: string;
}

/** Модель связи между сущностями */
export interface PartyPartyRelDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format uuid
   */
  id?: string;
  /** Тип связи */
  relationType?: "CONTACT_PERSON" | "CHILD_COMPANY" | "PARENT_COMPANY";
  /** Название связи */
  relationTitle?: string;
  /** Описание связи */
  description?: string;
  /**
   * Связать кого
   * @format uuid
   */
  fromId?: string;
  /** Тип отношения ведомого к ведущему */
  fromType?: "COMPANY" | "PERSON" | "CONTRACTOR";
  /**
   * Связать с кем
   * @format uuid
   */
  toId?: string;
  /** Тип отношения ведущего к ведомому */
  toType?: "COMPANY" | "PERSON" | "CONTRACTOR";
}

export interface Payer {
  /** @example "Конус плюс" */
  name?: string;
  /** @example "0326489404" */
  inn?: string;
  /** @example "032301001" */
  kpp?: string;
}

/** Способ банковского взаимодействия, перечислений, платежей Компании */
export interface PaymentDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format uuid
   */
  id?: string;
  /**
   * Компания-владелец данного способа оплаты
   * @format uuid
   */
  companyId: string;
  /**
   * Наименование банка
   * @minLength 3
   * @maxLength 255
   */
  bankName: string;
  /**
   * КПП
   * @minLength 3
   * @maxLength 127
   */
  kpp?: string;
  /**
   * БИК
   * @minLength 3
   * @maxLength 127
   */
  bik?: string;
  /**
   * Корреспондентский счёт
   * @minLength 3
   * @maxLength 127
   */
  cor?: string;
  /** Расчётный счёт */
  rs?: string;
}

export interface PersonDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format uuid
   */
  id?: string;
  /** Тип отношений между ведущим и ведомым работником (или компанией) */
  partyType?: "COMPANY" | "PERSON" | "CONTRACTOR";
  email?: string;
  phoneNumber?: string;
  phoneNumber2?: string;
  firstName?: string;
  patronymic?: string;
  lastName?: string;
  userLogin?: string;
  /** @format date */
  birthDate?: string;
  /**
   * Связь контактного лица с компанией (или другим лицом)
   * @uniqueItems true
   */
  relations: PartyPartyRelDto[];
}

export interface RawTariffDto {
  /**
   * Идентификатор тарифа в БД
   * @format int64
   */
  id?: number;
  /** Название тарифа */
  title: string;
  /**
   * Доступное дисковое пространство
   * @format int64
   */
  diskSpace?: number;
  /**
   * Срок действия тарифа
   * @format int64
   */
  sortOrder: number;
  /** @uniqueItems true */
  durations?: TariffPeriodsRecord[];
  popularPricingPlan?: boolean;
  availableDiscSpaceExtend?: boolean;
}

export interface ReasonDelayDto {
  /**
   * ID
   * @format int64
   */
  id?: number;
  /** @format int64 */
  serviceRequestId: number;
  /** @format date-time */
  date?: string;
  comment?: string;
  /** @format uuid */
  documentId: string;
  document?: DocumentDto;
  /** @format uuid */
  documentId2?: string;
  document2?: DocumentDto;
  /**
   * Для offline заведения заявки
   * @format uuid
   */
  offlineReqId?: string;
}

/** Модель причины отмены заявки */
export interface ReasonRejectionDictDto {
  /** ID */
  code?: string;
  name?: string;
  /** Описание */
  description?: string;
  /** @format int32 */
  sortOrder?: number;
  /**
   * Дата удаления
   * @format date-time
   */
  deletedDate?: string;
}

/** Основное тело шаблона */
export interface ReportTemplateRecord {
  /**
   * ID шаблона
   * @format int64
   */
  id?: number;
  "Template name": string;
  "Description comment"?: string;
  /**
   * Доступен ли для всех членов компании?
   * @default "false"
   */
  isPublic?: boolean;
  /** JSON-тело шаблона */
  body: JsonNode;
  /**
   * ID компании создателя шаблона
   * @format uuid
   */
  companyId: string;
}

export interface SRDetails {
  /** @format int64 */
  id?: number;
  manager?: string;
  workers?: string;
  customer?: string;
  fullAddress?: string;
  serviceType?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  executedDate?: string;
  /** @format date-time */
  plannedDate?: string;
  statusCode?: string;
  workLocation?: string;
  archived?: boolean;
}

export interface SRStatus {
  statusCode?: string;
  statusName?: string;
  /** @format int32 */
  sortOrder?: number;
  active?: boolean;
}

/** Модель новой заявки */
export interface ServiceRequestDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id в БД
   * @format int64
   */
  id?: number;
  /** Модель контракта */
  contract?: ContractDto;
  /**
   * ID контракта заявки
   * @format int64
   */
  contractId: number;
  /**
   * Лицевой счёт (может отсутствовать)
   * @minLength 0
   * @maxLength 50
   */
  extNumber?: string;
  statusCode?: string;
  /** Район электрической станции */
  res?: string;
  /** Примерная модель искомого адреса */
  address?: FullAddressDto;
  /** Юрлицо, физик, ИП или СЗ */
  legalType:
    | "OTHER"
    | "SELF_EMPLOYED"
    | "INDIVIDUAL"
    | "PHYSICAL"
    | "JURIDICAL";
  /** Менеджер-ответственный (для исходящих) */
  manager?: UserAccountDto;
  /**
   * UID менеджера-ответственного
   * @format uuid
   */
  managerUid?: string;
  managerFio?: string;
  workers?: UserAccountDto[];
  workerUids?: string[];
  workersFio?: string;
  workerGroup?: BrigadeGroupDto;
  /** @format uuid */
  workerGroupId?: string;
  /**
   * Дата начала выполнения
   * @format date-time
   */
  startDate?: string;
  /**
   * Дата планового выполнения
   * @format date-time
   */
  plannedDate?: string;
  /**
   * Дата фактического выполнения
   * @format date-time
   */
  executedDate?: string;
  sourceContent?: Record<string, object>;
  workData?: Record<string, object>;
  /** Оборудование из справочника оборудования */
  device?: DeviceDictionaryDto;
  /** Тип услуги */
  serviceType: ServiceTypesDictDto;
  /**
   * ID оборудования из справочника
   * @format int64
   */
  deviceId?: number;
  /** Описание заявки */
  description?: string;
  reasonStatusCodeChanged?: string;
  reasonRejectionCode?: string;
  /** Модель причины отмены заявки */
  reasonRejection?: ReasonRejectionDictDto;
  /** @format int32 */
  reasonDelayCount?: number;
  /**
   * ID компании-владельца заявки
   * @format uuid
   */
  companyId: string;
  companyName?: string;
  /** Возвращена ли заявка на доработку */
  onRevision?: boolean;
  /** Контактные лица */
  customers?: UserAccountDto[];
  /**
   * Для offline заведения заявки
   * @format uuid
   */
  offlineReqId?: string;
  archived?: boolean;
  taskLocationCode?: string;
  /** Модель места проведения работ */
  taskLocation?: ContractLocationsDictDto;
  /**
   * @minLength 0
   * @maxLength 100
   */
  customer?: string;
  /**
   * @minLength 0
   * @maxLength 64
   */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 64
   */
  customerPhone?: string;
}

export interface ServiceRequestMetadataDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 100
   */
  modelName: string;
}

export interface ServiceRequestShortDto {
  /**
   * id в БД
   * @format int64
   */
  id?: number;
  companyName?: string;
  contractNumber?: string;
  /**
   * Дата начала контракта
   * @format date-time
   */
  contractStartDate?: string;
  manager?: string;
  workers?: string;
  fullAddress?: string;
  /** Тип услуги */
  serviceType: string;
  /** @format date-time */
  createdDate?: string;
  /**
   * Дата планового выполнения
   * @format date-time
   */
  plannedDate?: string;
  /**
   * Дата фактического выполнения
   * @format date-time
   */
  executedDate?: string;
  statusCode?: string;
  workLocation?: string;
  archived?: boolean;
  /**
   * @deprecated
   * @minLength 0
   * @maxLength 100
   */
  customer?: string;
}

export type ServiceRequestSpec = object;

export interface ServiceRequestStatusHistoryDto {
  /**
   * ID
   * @format int64
   */
  id?: number;
  /** @format int32 */
  rev?: number;
  statusCode?: string;
  reasonStatusCodeChanged?: string;
  description?: string;
  author?: UserAccountDto;
  /** @format date-time */
  date?: string;
  archived?: boolean;
}

/** Тип услуги */
export interface ServiceTypesDictDto {
  /** @format int64 */
  id?: number;
  /** ID */
  code?: string;
  higherCode?: string;
  /**
   * Компания-владелец услуги
   * @format uuid
   */
  companyId: string;
  name?: string;
  /** Описание */
  description?: string;
  /** @format int32 */
  sortOrder?: number;
  /**
   * Дата удаления
   * @format date-time
   */
  deletedDate?: string;
  /** Имя услуги на сайте */
  ui_name?: string;
}

export interface SortObject {
  sorted?: boolean;
  unsorted?: boolean;
  empty?: boolean;
}

export interface StatusCount {
  status?: string;
  /** @format int64 */
  count?: number;
  /** @format int32 */
  year?: number;
}

export type StreamingResponseBody = object;

export interface TariffPeriodsRecord {
  /** @format int64 */
  id?: number;
  period?: string;
  description?: string;
  /** @format int64 */
  price?: number;
}

export interface Tax {
  kbk?: string;
  oktmo?: string;
  payerStatus?: string;
  evidence?: string;
  period?: string;
  nalType?: string;
  docNumber?: string;
  docDate?: string;
  uin?: string;
  thirdPartyInn?: string;
  thirdPartyKpp?: string;
}

export interface TbankDataDto {
  balances?: Balance;
  operations?: Operation[];
  nextCursor?: string;
}

/** Форма заявки на оплату с фронта */
export interface TbankSendDto {
  invoiceNumber?: string;
  /**
   * Дата создания платежа
   * @example "2025-09-02"
   */
  invoiceDate?: string;
  /**
   * Дедлайн платежа
   * @example "2025-09-03"
   */
  dueDate?: string;
  /** @example 40702810810001910000 */
  accountNumber?: string;
  /**
   * Телефон для смс о платеже
   * @example "+792437132313"
   */
  contactPhone?: string;
  /**
   * Комментарий к платежу
   * @example "Тестовая проверка выставления счета (игнорировать)"
   */
  comment?: string;
  /** Плательщик (компания с инн и кпп) */
  payer?: Payer;
  /** Приобретаемые товары/услуги */
  items?: Item[];
  /** Почта для pdf о платеже */
  contacts?: Contact[];
  /** PDF ссылка на платёжку, если создан запрос на оплату в банк */
  pdfUrl?: string;
}

/** Ответ банка о создании контракта на оплату, включая id и pdf */
export interface TbankSendResponseDto {
  /** Номер учётный текущего контракта на оплату (он же - ID в таблице БД) */
  invoiceId?: string;
  /**
   * Уникальный ID запроса на оплату (с фронта)
   * @format uuid
   */
  requestId: string;
  /**
   * Ссылка на скачивание PDF на оплату текущего контракта
   * @example "https://business.tbank.ru/invoices/api/v1/public/document/R3lVYEg0VfwnBt3W9lScEK9B9mVZTiSA2zR6zd3BdRGSkHw3kg?nonce=anrZYzTL"
   */
  pdfUrl?: string;
  /** Ссылка на оплату через ЛК банка */
  incomingInvoiceUrl?: string;
  /** Статус проведения текущего контракта на оплату */
  status?: "DRAFT" | "SUBMITTED" | "EXECUTED" | "OVERDUE";
  /** @format date-time */
  createDate?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /**
   * Дата проведения оплаты
   * @format date-time
   */
  paymentDate?: string;
  payerName?: string;
  /** @format date-time */
  dueDate?: string;
  /** @format date-time */
  invoiceDate?: string;
  /** @format uuid */
  companyId?: string;
  value?: number;
  /** @format int64 */
  companiesTariffId?: number;
  /** @format int64 */
  companiesTariffPeriodId?: number;
  /** @maxLength 127 */
  innerContractNumber?: string;
}

export interface Totals {
  statuses?: StatusCount[];
  lastStatuses?: StatusCount[];
  leadTimes?: LeadTimes;
}

export interface UserAccountDto {
  /**
   * UID пользователя (KC)
   * @format uuid
   */
  uid?: string;
  /**
   * Логин
   * @minLength 3
   * @maxLength 50
   * @pattern ^\S+$
   */
  userLogin: string;
  /** ФИО */
  userFIO?: string;
  /**
   * Дата последнего входа
   * @format date-time
   */
  lastLoginDate?: string;
  /**
   * Список ролей
   * @uniqueItems true
   */
  roles?: (
    | "ROLE_ANONYMOUS"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /** Должность, позиция или типа того */
  position?: string;
  /** Электронная почта пользователя */
  email: string;
  /**
   * Верифицирована ли электронная почта?
   * @default "false"
   */
  emailVerified?: boolean;
  /** Номер телефона */
  phoneNumber?: string;
  /**
   * Верифицирован ли номер телефона?
   * @default "false"
   */
  phoneNumberVerified?: boolean;
  /** Имя */
  firstName?: string;
  /** Отчество */
  patronymic?: string;
  /** Фамилия */
  lastName?: string;
  /**
   * Компания пользователя
   * @format uuid
   */
  companyId?: string;
  password?: UserAccountDto;
  active?: boolean;
  /** Бригады данного рабочего */
  groups?: BrigadeGroupDto[];
}

export interface UserErrorMessage {
  /** @format date-time */
  timestamp?: string;
  code?: string;
  cause?: string;
  title?: string;
  message?: string;
  errorName?: string;
}

/** WorkContent заявки/услуги */
export interface WorkContentDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 256
   */
  name: string;
  modelName: string;
  /** Тип контента (WorkContent) */
  type:
    | "MODEL"
    | "DOCUMENTS"
    | "SOURCE_CONTENT"
    | "WORK_DATA"
    | "DEVICE_DICTIONARY"
    | "ANY";
  stage?: WorkStageDto;
  /**
   * Номер этапа заполнения (шага) в приложении
   * @format int64
   */
  stageId: number;
  /**
   * Является ли обязательным для заполнения
   * @default "true"
   */
  mandatory?: boolean;
  /** @format int32 */
  sortOrder?: number;
  defaultValue?: string;
  /** Тип данных */
  inputType?:
    | "TEXT"
    | "NUMBER"
    | "DATE"
    | "BARCODE"
    | "IMAGE"
    | "STRING"
    | "FILE_PICKER"
    | "VIDEO"
    | "AUDIO"
    | "MULTIPLE";
  /**
   * Допускается ли правка значения
   * @default "true"
   */
  editable?: boolean;
  /**
   * В режиме доработки (после первичного завершения)
   * @default "false"
   */
  forRevisionOnly?: boolean;
  /**
   * Только для web-отображения (не на мобилке)
   * @default "false"
   */
  forWebOnly?: boolean;
  availableFileExtensions?: string;
  /** @format int32 */
  maxFilesAllowed?: number;
  /**
   * Для offline заведения заявки
   * @format uuid
   */
  offlineReqId?: string;
  deleted?: boolean;
  /** Тип услуги */
  deviceType?: ServiceTypesDictDto;
  /** @format int64 */
  fieldId?: number;
}

/** WorkContent заявки/услуги (контент шага исполнения заявки) */
export interface WorkContentFullDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format int64
   */
  id?: number;
  name?: string;
  modelName?: string;
  /** Тип контента (WorkContent) */
  type?:
    | "MODEL"
    | "DOCUMENTS"
    | "SOURCE_CONTENT"
    | "WORK_DATA"
    | "DEVICE_DICTIONARY"
    | "ANY";
  stage?: WorkStageDto;
  /** @format int64 */
  stageId?: number;
  mandatory?: boolean;
  /** @format int32 */
  sortOrder?: number;
  /** Составляющая часть WorkContent заявки/услуги */
  item?: WorkContentItemDto;
  /** @format int64 */
  itemId?: number;
  /** @format date-time */
  deletedDate?: string;
  defaultValue?: string;
  /** Тип данных */
  inputType?:
    | "TEXT"
    | "NUMBER"
    | "DATE"
    | "BARCODE"
    | "IMAGE"
    | "STRING"
    | "FILE_PICKER"
    | "VIDEO"
    | "AUDIO"
    | "MULTIPLE";
  forRevisionOnly?: boolean;
  forWebOnly?: boolean;
  editable?: boolean;
  availableFileExtensions?: string;
  /** @format int32 */
  maxFilesAllowed?: number;
  deleted?: boolean;
  /** Тип услуги */
  deviceType?: ServiceTypesDictDto;
  field?: ServiceRequestMetadataDto;
  /** @format int64 */
  fieldId?: number;
}

/** Составляющая часть WorkContent заявки/услуги */
export interface WorkContentItemDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /** @format int64 */
  serviceRequestId?: number;
  /** WorkContent заявки/услуги */
  workContent?: WorkContentDto;
  /** @format int64 */
  workContentId: number;
  modelName?: string;
  /** @format uuid */
  offlineReqId?: string;
}

export type WorkContentSpec = object;

/** Текстовая составляющая часть WorkContent заявки/услуги */
export interface WorkContentTextItemDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /** @format int64 */
  serviceRequestId?: number;
  /** WorkContent заявки/услуги */
  workContent?: WorkContentDto;
  /** @format int64 */
  workContentId: number;
  modelName?: string;
  /** @format uuid */
  offlineReqId?: string;
  text?: string;
  description?: string;
}

/** Модель импорта (WorkData) */
export interface WorkDataImportDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * id в БД
   * @format uuid
   */
  id?: string;
  /**
   * uid инициатора импорта
   * @format uuid
   */
  initiatorUid?: string;
  initiator?: UserAccountDto;
  /**
   * Компания
   * @format uuid
   */
  companyId: string;
  /** Комментарий */
  comment?: string;
  /** Статус парсинга импорта (excel) */
  statusCode?:
    | "WAITING_FOR_START"
    | "PROCESSING"
    | "FINISHED_SUCCESSFULLY"
    | "FINISHED_WITH_ERRORS"
    | "REJECTED";
  /** @format uuid */
  sourceDocumentId?: string;
  sourceDocument?: DocumentDto;
  /** @format date-time */
  importStartDate?: string;
  /** @format date-time */
  importFinishDate?: string;
  /** @format int32 */
  totalRowCount?: number;
  /** @format int32 */
  successRowCount?: number;
  /** @format int32 */
  updateRowCount?: number;
  /** @format int32 */
  addRowCount?: number;
  /** @format int32 */
  skipRowCount?: number;
  /** @format int32 */
  failedRowCount?: number;
  /** @format uuid */
  errorDocumentId?: string;
  errorDocument?: DocumentDto;
  /** Тип услуги */
  serviceType?: ServiceTypesDictDto;
  /**
   * Контракт
   * @format int64
   */
  taskId?: number;
}

export interface WorkStageDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format int64
   */
  id?: number;
  name?: string;
  /** @uniqueItems true */
  availableForRoles: (
    | "ROLE_ANONYMOUS"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /** @uniqueItems true */
  availableForEdit: (
    | "ROLE_ANONYMOUS"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /** @uniqueItems true */
  availableForStatuses: string[];
  /** @format int32 */
  sortOrder?: number;
  forRevisionOnly?: boolean;
  needToPreSave?: boolean;
  /** Тип услуги */
  deviceType?: ServiceTypesDictDto;
}

/** Это одна часть коллекции легендарного contentTree */
export interface WorkStageFullDto {
  /** Создатель записи */
  createdBy: string;
  /** Автор последнего изменения */
  lastModifiedBy?: string;
  /**
   * Дата создания записи
   * @format date-time
   */
  createdDate: string;
  /**
   * Дата последнего изменения
   * @format date-time
   */
  lastModifiedDate?: string;
  /**
   * ID
   * @format int64
   */
  id?: number;
  /** Название шага */
  name: string;
  /** Коллекция полезной нагрузки шага */
  workContents?: WorkContentFullDto[];
  /**
   * Роли, имеющие доступ к данному шагу
   * @uniqueItems true
   */
  availableForRoles?: (
    | "ROLE_ANONYMOUS"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /**
   * Роли, имеющие возможность править данные на этом шаге
   * @uniqueItems true
   */
  availableForEdit?: (
    | "ROLE_ANONYMOUS"
    | "ROLE_VIEWER"
    | "ROLE_CUSTOMER"
    | "ROLE_WORKER"
    | "ROLE_MANAGER"
    | "ROLE_PROJECT_MANAGER"
    | "ROLE_DIRECTOR"
    | "ROLE_FUNCTIONAL_ADMIN"
    | "ROLE_OWNER"
    | "ROLE_ADMIN"
    | "ROLE_DEVELOPER"
    | "ROLE_FRONTEND"
  )[];
  /**
   * Статус заявки, где отображается данный шаг
   * @uniqueItems true
   */
  availableForStatuses?: string[];
  /**
   * Позиция шага (порядковый номер)
   * @format int32
   */
  sortOrder: number;
  /** Доступно ли только при модерации/доработке? */
  forRevisionOnly?: boolean;
  /** Схраненяется ли без фактического завершения пути? */
  needToPreSave?: boolean;
  /** Тип устройства */
  deviceType: ServiceTypesDictDto;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://192.168.0.203:8080",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Service Desk Api
 * @version 1.4.84
 * @baseUrl http://192.168.0.203:8080
 * @contact Konus-group <info@konus.group> (https://www.konus.group)
 *
 * Service desk System
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  workContents = {
    /**
     * @description  (@FunctionalAdmin)
     *
     * @tags WorkContents
     * @name PutWorkContents
     * @summary Обновить WorkContent
     * @request PUT:/workContents
     * @secure
     */
    putWorkContents: (data: WorkContentDto, params: RequestParams = {}) =>
      this.request<WorkContentDto, UserErrorMessage>({
        path: `/workContents`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@FunctionalAdmin)
     *
     * @tags WorkContents
     * @name PostWorkContents
     * @summary Создать WorkContent
     * @request POST:/workContents
     * @secure
     */
    postWorkContents: (data: WorkContentDto, params: RequestParams = {}) =>
      this.request<WorkContentDto, UserErrorMessage>({
        path: `/workContents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Доступно при статусе IN_PROGRESS (@Worker)
     *
     * @tags WorkContents
     * @name PostWorkContentsSrIdContentWorksData
     * @summary Установка текстовых контентов
     * @request POST:/workContents/{srId}/content/WORKS_DATA
     * @secure
     */
    postWorkContentsSrIdContentWorksData: (
      srId: number,
      data: WorkContentTextItemDto[],
      query?: {
        /**
         * Для идемпотентности запроса
         * @format uuid
         */
        offlineRequestId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkContentTextItemDto[], UserErrorMessage>({
        path: `/workContents/${srId}/content/WORKS_DATA`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Доступно работнику при IN_PROGRESS, менеджеру при EXECUTED (@Worker)
     *
     * @tags WorkContents
     * @name PostWorkContentsIdContentDocs
     * @summary Установка загружаемого контента (documents) определенного вида по заявке
     * @request POST:/workContents/{id}/content/docs
     * @secure
     */
    postWorkContentsIdContentDocs: (
      id: number,
      query: {
        /** Тип документа */
        docType:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
        docFiles: File[];
        docDescriptions?: string[];
        /** @format int64 */
        workContentId: number;
        modelName?: string;
        /**
         * Для идемпотентности запроса
         * @format uuid
         */
        offlineRequestId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkContentItemDto, UserErrorMessage>({
        path: `/workContents/${id}/content/docs`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращается массивом, только имеющийся контент (@Viewer)
     *
     * @tags WorkContents
     * @name GetWorkContentsIdContent
     * @summary Получить весь контент по заявке
     * @request GET:/workContents/{id}/content
     * @secure
     */
    getWorkContentsIdContent: (id: number, params: RequestParams = {}) =>
      this.request<WorkContentItemDto[], UserErrorMessage>({
        path: `/workContents/${id}/content`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Список WorkContent по критериям (@Worker)
     *
     * @tags WorkContents
     * @name GetWorkContentsWorkContents
     * @summary Найти WorkContent
     * @request GET:/workContents/workContents
     * @secure
     */
    getWorkContentsWorkContents: (
      query: {
        spec: WorkContentSpec;
        pageable: Pageable;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageWorkContentDto, UserErrorMessage>({
        path: `/workContents/workContents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  serviceRequests = {
    /**
     * @description Заявки доступные назначенному пользователю (или группе) (@Worker)
     *
     * @tags Service requests
     * @name GetServiceRequests
     * @summary Получение доступных заявок
     * @request GET:/serviceRequests
     * @secure
     */
    getServiceRequests: (
      query?: {
        /**
         * ID заявки
         * @format int64
         * @example 1
         */
        id?: number;
        /**
         * Порядковый номер
         * @format int64
         * @example 1
         */
        counter?: number;
        /**
         * Статус заявки
         * @uniqueItems true
         */
        status?: string[];
        /**
         * ID контракта
         * @format int64
         * @example 1
         */
        contractId?: number;
        /**
         * Идентификатор контракта
         * @example "some-12345"
         */
        contractNumber?: string;
        /**
         * Лицевой счёт
         * @example 1400635040
         */
        extNumber?: string;
        /**
         * Район
         * @example "Выборгское"
         */
        district?: string;
        /**
         * Регион, область, край
         * @example "Ленинградская область"
         */
        region?: string;
        /**
         * Населённый пункт
         * @example "Выборг"
         */
        city?: string;
        /**
         * Улица
         * @example "Ленинградское"
         */
        street?: string;
        /**
         * Полный адрес
         * @example "г.Москва, ул.Чернышева, д.5"
         */
        fullAddress?: string;
        /**
         * Номер дома
         * @example 99
         */
        house?: string;
        /**
         * Квартира
         * @example 38
         */
        apartment?: string;
        /**
         * Вид услуги
         * @example "ELECTRICITY_METER"
         */
        serviceType?: string;
        /**
         * Номер устройства (старого)
         * @example 624360
         */
        deviceNumberOld?: string;
        /**
         * Номер устройства (нового)
         * @example 624360
         */
        deviceNumberNew?: string;
        /**
         * ID менеджера
         * @format uuid
         */
        managerUid?: string;
        /**
         * UID работника
         * @format uuid
         */
        workerUid?: string;
        /**
         * ID бригады работника
         * @format uuid
         * @example "90e4dece-b832-4a23-be95-a1c9bd40c2f6"
         */
        workerGroupId?: string;
        /**
         * Тип расположения
         * @example "APARTMENT"
         */
        contractLocation?: string;
        /**
         * Количество задержек
         * @format int32
         */
        reasonDelayCount?: number;
        /**
         * Со статусом архивных?
         * @default false
         */
        archive?: boolean;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageServiceRequestDto, UserErrorMessage>({
        path: `/serviceRequests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновление существующей заявки (@Manager)
     *
     * @tags Service requests
     * @name PutServiceRequests
     * @summary Обновление заявки
     * @request PUT:/serviceRequests
     * @secure
     */
    putServiceRequests: (data: ServiceRequestDto, params: RequestParams = {}) =>
      this.request<ServiceRequestDto, UserErrorMessage>({
        path: `/serviceRequests`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание новой заявки руками (через веб-форму) (@ManagerOrCustomer)
     *
     * @tags Service requests
     * @name PostServiceRequests
     * @summary Ручное создание заявки
     * @request POST:/serviceRequests
     * @secure
     */
    postServiceRequests: (
      data: ServiceRequestDto,
      query?: {
        /**
         * Для идемпотентности запроса
         * @format uuid
         */
        requestId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ServiceRequestDto, UserErrorMessage>({
        path: `/serviceRequests`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Установка статуса указанной заявки менеджером или исполнителем (@Worker)
     *
     * @tags Service requests
     * @name PutServiceRequestsSrIdStatus
     * @summary Установка статуса заявки
     * @request PUT:/serviceRequests/{srId}/status
     * @secure
     */
    putServiceRequestsSrIdStatus: (
      srId: number,
      query: {
        /** Статус заявки */
        status: string;
        /**
         * ID оборудования
         * @format int64
         */
        deviceId?: number;
        /** Комментарий */
        comment?: string;
        /**
         * Дата оффлайн запроса
         * @format date-time
         */
        modifiedDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, UserErrorMessage>({
        path: `/serviceRequests/${srId}/status`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Назначить исполнителя указанной заявки (@Worker)
     *
     * @tags Service requests
     * @name PutServiceRequestsSrIdSetWorker
     * @summary Назначение исполнителя заявки
     * @request PUT:/serviceRequests/{srId}/setWorker
     * @secure
     */
    putServiceRequestsSrIdSetWorker: (
      srId: number,
      query: {
        /**
         * ID исполнителя
         * @format int64
         */
        workerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/${srId}/setWorker`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service requests
     * @name PutServiceRequestsSrIdSetWorkerAndGroup
     * @summary Назначение исполнителя и бригады (@Manager)
     * @request PUT:/serviceRequests/{srId}/setWorkerAndGroup
     * @secure
     */
    putServiceRequestsSrIdSetWorkerAndGroup: (
      srId: number,
      query: {
        /**
         * ID исполнителя
         * @format int64
         */
        workerId: number;
        /**
         * ID бригады/группы
         * @format uuid
         */
        groupId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/${srId}/setWorkerAndGroup`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Привязка конкретного оборудования к указанной заявке (@Manager)
     *
     * @tags Service requests
     * @name PutServiceRequestsSrIdSetDevice
     * @summary Назначение оборудования
     * @request PUT:/serviceRequests/{srId}/setDevice
     * @secure
     */
    putServiceRequestsSrIdSetDevice: (
      srId: number,
      query: {
        /**
         * ID оборудования
         * @format int64
         */
        deviceId: number;
        /**
         * Дата оффлайн запроса
         * @format date-time
         */
        modifiedDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/${srId}/setDevice`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@Worker)
     *
     * @tags Service requests
     * @name PutServiceRequestsSrIdDescription
     * @summary Установка описания заявки
     * @request PUT:/serviceRequests/{srId}/description
     * @secure
     */
    putServiceRequestsSrIdDescription: (
      srId: number,
      query: {
        /** Описание */
        description: string;
        /**
         * Дата оффлайн запроса
         * @format date-time
         */
        modifiedDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, UserErrorMessage>({
        path: `/serviceRequests/${srId}/description`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description  (@Manager)
     *
     * @tags Service requests
     * @name PutServiceRequestsSrIdClearExecutor
     * @summary Сброс назначений менеджером
     * @request PUT:/serviceRequests/{srId}/clearExecutor
     * @secure
     */
    putServiceRequestsSrIdClearExecutor: (
      srId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/${srId}/clearExecutor`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Взять заявку(ки) в работу исполнителем (текущим пользователем) (@Worker)
     *
     * @tags Service requests -> Take
     * @name PutServiceRequestsTake
     * @summary Взять заявки в работу исполнителем
     * @request PUT:/serviceRequests/take
     * @secure
     */
    putServiceRequestsTake: (data: number[], params: RequestParams = {}) =>
      this.request<void, UserErrorMessage>({
        path: `/serviceRequests/take`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Заявки, добавленные в Избранное (@Viewer)
     *
     * @tags Service requests -> Favorites
     * @name GetServiceRequestsFavorites
     * @summary Получение избранных заявок
     * @request GET:/serviceRequests/favorites
     * @secure
     */
    getServiceRequestsFavorites: (
      query?: {
        /**
         * UID пользователя (если нужны не свои)
         * @format uuid
         */
        userUid?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageServiceRequestDto, UserErrorMessage>({
        path: `/serviceRequests/favorites`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменить статус заявки как 'Избранной' указанным пользователем (@Viewer)
     *
     * @tags Service requests -> Favorites
     * @name PutServiceRequestsFavorites
     * @summary Смена статуса избранного заявки
     * @request PUT:/serviceRequests/favorites
     * @secure
     */
    putServiceRequestsFavorites: (
      query: {
        /**
         * UID пользователя
         * @format uuid
         */
        userUid: string;
        /**
         * ID заявки
         * @format int64
         */
        srId: number;
        /** Пометить как избранное? */
        isFavorite: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/favorites`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Доступно в статусах: [CREATED, READY_TO_PROCESS, IN_PROGRESS, EXECUTED] (@Manager)
     *
     * @tags Service requests
     * @name PostServiceRequestsSrIdReject
     * @summary Отмена заявки с указанием причины
     * @request POST:/serviceRequests/{srId}/reject
     * @secure
     */
    postServiceRequestsSrIdReject: (
      srId: number,
      query: {
        /** Причина отмены */
        reasonRejectionCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/${srId}/reject`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Групповое назначение указанных исполнителей на указанные заявки (@Manager)
     *
     * @tags Service requests
     * @name PostServiceRequestsSetWorkers
     * @summary Назначение исполнителей на заявки
     * @request POST:/serviceRequests/setWorkers
     * @secure
     */
    postServiceRequestsSetWorkers: (
      query: {
        /** Коллекция UID исполнителей */
        workerUid: string[];
      },
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/setWorkers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Групповое назначение бригады на указанные заявки (@Manager)
     *
     * @tags Service requests
     * @name PostServiceRequestsSetWorkerGroup
     * @summary Назначение бригады на заявки
     * @request POST:/serviceRequests/setWorkerGroup
     * @secure
     */
    postServiceRequestsSetWorkerGroup: (
      query: {
        /**
         * ID бригады/группы
         * @format uuid
         */
        groupId: string;
      },
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/setWorkerGroup`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Групповое назначение исполнителя и бригады на указанные заявки (@Manager)
     *
     * @tags Service requests
     * @name PostServiceRequestsSetWorkerAndGroup
     * @summary Назначение исполнителя и бригады на заявки
     * @request POST:/serviceRequests/setWorkerAndGroup
     * @secure
     */
    postServiceRequestsSetWorkerAndGroup: (
      query: {
        /**
         * UID исполнителя
         * @format uuid
         */
        workerUid: string;
        /**
         * ID бригады/группы
         * @format uuid
         */
        groupId: string;
      },
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/setWorkerAndGroup`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Групповое назначение менеджера на указанные заявки (@Director)
     *
     * @tags Service requests
     * @name PostServiceRequestsSetManager
     * @summary Назначение менеджера на заявки
     * @request POST:/serviceRequests/setManager
     * @secure
     */
    postServiceRequestsSetManager: (
      query: {
        /**
         * UID менеджера
         * @format uuid
         */
        managerUid: string;
      },
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/setManager`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Назначение исполнителя указанным заявкам (@Worker)
     *
     * @tags Service requests -> Leader
     * @name PostServiceRequestsLeaderSetWorkers
     * @summary Назначение исполнителя заявок
     * @request POST:/serviceRequests/leader/setWorkers
     * @secure
     */
    postServiceRequestsLeaderSetWorkers: (
      query: {
        /**
         * UID исполнителя
         * @format uuid
         */
        workerUid: string;
      },
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/leader/setWorkers`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Снять всех исполнителей с указанных заявок (@Worker)
     *
     * @tags Service requests -> Leader
     * @name PostServiceRequestsLeaderClearExecutor
     * @summary Сброс назначений бригадиром
     * @request POST:/serviceRequests/leader/clearExecutor
     * @secure
     */
    postServiceRequestsLeaderClearExecutor: (
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/leader/clearExecutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@Viewer)
     *
     * @tags Service requests
     * @name PostServiceRequestsFindByIds
     * @summary Найти заявки по id
     * @request POST:/serviceRequests/findByIds
     * @secure
     */
    postServiceRequestsFindByIds: (
      data: number[],
      query?: {
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageServiceRequestDto, UserErrorMessage>({
        path: `/serviceRequests/findByIds`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@Manager)
     *
     * @tags Service requests
     * @name PostServiceRequestsClearExecutor
     * @summary Сброс назначений на заявки
     * @request POST:/serviceRequests/clearExecutor
     * @secure
     */
    postServiceRequestsClearExecutor: (
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/clearExecutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Заархивировать заявку (@Manager)
     *
     * @tags Service requests -> Архив
     * @name PostServiceRequestsArchive
     * @summary Управление архивацией
     * @request POST:/serviceRequests/archive
     * @secure
     */
    postServiceRequestsArchive: (
      query: {
        /**
         * id заявки
         * @format int64
         */
        srId: number;
        /** Сделать ли архивным? */
        isArchived: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/serviceRequests/archive`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить историю всех статусов указанной заявки (@Viewer)
     *
     * @tags Service requests
     * @name GetServiceRequestsSrIdStatuses
     * @summary История заявки
     * @request GET:/serviceRequests/{srId}/statuses
     * @secure
     */
    getServiceRequestsSrIdStatuses: (
      srId: number,
      params: RequestParams = {},
    ) =>
      this.request<ServiceRequestStatusHistoryDto[], UserErrorMessage>({
        path: `/serviceRequests/${srId}/statuses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращается доступный контент в виде дерева (@Viewer)
     *
     * @tags Service requests
     * @name GetServiceRequestsSrIdContentTree
     * @summary Получить легендарный ContentTree
     * @request GET:/serviceRequests/{srId}/contentTree
     * @secure
     */
    getServiceRequestsSrIdContentTree: (
      srId: number,
      params: RequestParams = {},
    ) =>
      this.request<WorkStageFullDto[], UserErrorMessage>({
        path: `/serviceRequests/${srId}/contentTree`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Урезанные заявки доступные назначенному пользователю (или группе) (@Worker)
     *
     * @tags Service requests
     * @name GetServiceRequestsList
     * @summary Получение доступных заявок (урезанный)
     * @request GET:/serviceRequests/list
     * @secure
     */
    getServiceRequestsList: (
      query?: {
        /**
         * ID заявки
         * @format int64
         * @example 1
         */
        id?: number;
        /**
         * Порядковый номер
         * @format int64
         * @example 1
         */
        counter?: number;
        /**
         * Статус заявки
         * @uniqueItems true
         */
        status?: string[];
        /**
         * ID контракта
         * @format int64
         * @example 1
         */
        contractId?: number;
        /**
         * Идентификатор контракта
         * @example "some-12345"
         */
        contractNumber?: string;
        /**
         * Лицевой счёт
         * @example 1400635040
         */
        extNumber?: string;
        /**
         * Район
         * @example "Выборгское"
         */
        district?: string;
        /**
         * Регион, область, край
         * @example "Ленинградская область"
         */
        region?: string;
        /**
         * Населённый пункт
         * @example "Выборг"
         */
        city?: string;
        /**
         * Улица
         * @example "Ленинградское"
         */
        street?: string;
        /**
         * Полный адрес
         * @example "г.Москва, ул.Чернышева, д.5"
         */
        fullAddress?: string;
        /**
         * Номер дома
         * @example 99
         */
        house?: string;
        /**
         * Квартира
         * @example 38
         */
        apartment?: string;
        /**
         * Вид услуги
         * @example "ELECTRICITY_METER"
         */
        serviceType?: string;
        /**
         * Номер устройства (старого)
         * @example 624360
         */
        deviceNumberOld?: string;
        /**
         * Номер устройства (нового)
         * @example 624360
         */
        deviceNumberNew?: string;
        /**
         * ID менеджера
         * @format uuid
         */
        managerUid?: string;
        /**
         * UID работника
         * @format uuid
         */
        workerUid?: string;
        /**
         * ID бригады работника
         * @format uuid
         * @example "90e4dece-b832-4a23-be95-a1c9bd40c2f6"
         */
        workerGroupId?: string;
        /**
         * Тип расположения
         * @example "APARTMENT"
         */
        contractLocation?: string;
        /**
         * Количество задержек
         * @format int32
         */
        reasonDelayCount?: number;
        /**
         * Со статусом архивных?
         * @default false
         */
        archive?: boolean;
        /**
         * Период выборки данных для дашборда
         * @default "ALL"
         */
        period?: "WEEK" | "MONTH" | "QUARTER" | "YEAR" | "ALL";
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageServiceRequestShortDto, UserErrorMessage>({
        path: `/serviceRequests/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Заявки, тех групп, где он бригадир (@Viewer)
     *
     * @tags Service requests -> Leader
     * @name GetServiceRequestsLeader
     * @summary Получение доступных бригадиру заявок
     * @request GET:/serviceRequests/leader
     * @secure
     */
    getServiceRequestsLeader: (
      query: {
        spec: ServiceRequestSpec;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageServiceRequestDto, UserErrorMessage>({
        path: `/serviceRequests/leader`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  relations = {
    /**
     * @description Получение страниц всех связей между работниками и компаниями (@Manager)
     *
     * @tags Parties
     * @name GetRelations
     * @summary Получить связи
     * @request GET:/relations
     * @secure
     */
    getRelations: (
      query?: {
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagePartyPartyRelDto, UserErrorMessage>({
        path: `/relations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменение свойств связи между объектами (@Manager)
     *
     * @tags Parties
     * @name PutRelations
     * @summary Обновить (переопределить) связь
     * @request PUT:/relations
     * @secure
     */
    putRelations: (data: PartyPartyRelDto, params: RequestParams = {}) =>
      this.request<PartyPartyRelDto, UserErrorMessage>({
        path: `/relations`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Привязка компании или работника к другой компании или работнику (@Manager)
     *
     * @tags Parties
     * @name PostRelations
     * @summary Создать связь
     * @request POST:/relations
     * @secure
     */
    postRelations: (data: PartyPartyRelDto, params: RequestParams = {}) =>
      this.request<PartyPartyRelDto, UserErrorMessage>({
        path: `/relations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Отвязка компаний или работников от других компаний или работников (удаление связей) (@Manager)
     *
     * @tags Parties
     * @name DeleteRelations
     * @summary Разорвать связи по списку
     * @request DELETE:/relations
     * @secure
     */
    deleteRelations: (
      query: {
        /**
         * Коллекция ID связей
         * @uniqueItems true
         */
        id: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], UserErrorMessage>({
        path: `/relations`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка связей между работниками и компаниями по списку (@Manager)
     *
     * @tags Parties
     * @name PostRelationsFindByIDs
     * @summary Найти связи из списка
     * @request POST:/relations/findByIDs
     * @secure
     */
    postRelationsFindByIDs: (data: string[], params: RequestParams = {}) =>
      this.request<PartyPartyRelDto[], UserErrorMessage>({
        path: `/relations/findByIDs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  payment = {
    /**
     * @description  (@Manager)
     *
     * @tags Payments
     * @name PutPaymentCreate
     * @summary Завести новый контракт на оплату компанией
     * @request PUT:/payment/create
     * @secure
     */
    putPaymentCreate: (
      query: {
        /**
         * Компания
         * @format uuid
         */
        companyId: string;
        /**
         * Уникальный ID оплаты (с фронта)
         * @format uuid
         */
        requestId: string;
      },
      data: TbankSendDto,
      params: RequestParams = {},
    ) =>
      this.request<TbankSendResponseDto, UserErrorMessage>({
        path: `/payment/create`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить весь список профилей банковского расчёта (@Manager)
     *
     * @tags Payments
     * @name GetPayment
     * @summary Список профилей расчёта
     * @request GET:/payment
     * @secure
     */
    getPayment: (
      query?: {
        /**
         * Страница
         * @format int32
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagePaymentDto, UserErrorMessage>({
        path: `/payment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить весь список контрактов на оплату со статусами (историю) (@Manager)
     *
     * @tags Payments
     * @name GetPaymentTransactions
     * @summary Контракты на оплату (история)
     * @request GET:/payment/transactions
     * @secure
     */
    getPaymentTransactions: (
      query?: {
        /**
         * Фильтр по компании
         * @format uuid
         */
        companyId?: string;
        /**
         * Фильтр по id
         * @format uuid
         */
        id?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageTbankSendResponseDto, UserErrorMessage>({
        path: `/payment/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@Manager)
     *
     * @tags Payments
     * @name GetPaymentStatusUid
     * @summary Статус платежа
     * @request GET:/payment/status/{uid}
     * @secure
     */
    getPaymentStatusUid: (uid: string, params: RequestParams = {}) =>
      this.request<
        "DRAFT" | "SUBMITTED" | "EXECUTED" | "OVERDUE",
        UserErrorMessage
      >({
        path: `/payment/status/${uid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@Manager)
     *
     * @tags Payments
     * @name GetPaymentHistory
     * @summary История проведённых банком платежей
     * @request GET:/payment/history
     * @secure
     */
    getPaymentHistory: (params: RequestParams = {}) =>
      this.request<TbankDataDto, UserErrorMessage>({
        path: `/payment/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти профили банковского расчёта по id (@Manager)
     *
     * @tags Payments
     * @name GetPaymentFindByIDs
     * @summary Найти по ID
     * @request GET:/payment/findByIDs
     * @secure
     */
    getPaymentFindByIDs: (data: string[], params: RequestParams = {}) =>
      this.request<PaymentDto[], UserErrorMessage>({
        path: `/payment/findByIDs`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  models = {
    /**
     * @description Поиск модели оборудования (@Worker)
     *
     * @tags Device models
     * @name GetModels
     * @summary Поиск модели оборудования
     * @request GET:/models
     * @secure
     */
    getModels: (
      query?: {
        /** Модель оборудования для справочника устройств */
        modelName?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageDeviceModelDto, UserErrorMessage>({
        path: `/models`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновление существующей модели оборудования (@Manager)
     *
     * @tags Device models
     * @name PutModels
     * @summary Обновление модели оборудования
     * @request PUT:/models
     * @secure
     */
    putModels: (data: DeviceModelDto, params: RequestParams = {}) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/models`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Регистрация новой модели оборудования для корректной загрузки excel с данной моделью (@Manager)
     *
     * @tags Device models
     * @name PostModelsCreate
     * @summary Регистрация модели оборудования
     * @request POST:/models/create
     * @secure
     */
    postModelsCreate: (data: DeviceModelDto, params: RequestParams = {}) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/models/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  imports = {
    /**
     * @description Получить список всех существующих импортов (@Manager)
     *
     * @tags Imports
     * @name GetImports
     * @summary Получить все импорты
     * @request GET:/imports
     * @secure
     */
    getImports: (
      query?: {
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageImportDto, UserErrorMessage>({
        path: `/imports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующую запись импорта (@Manager)
     *
     * @tags Imports
     * @name PutImports
     * @summary Обновить импорт
     * @request PUT:/imports
     * @secure
     */
    putImports: (data: ImportDto, params: RequestParams = {}) =>
      this.request<ImportDto, UserErrorMessage>({
        path: `/imports`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Завести новый WorkDataImport (@Manager)
     *
     * @tags Imports
     * @name PostImportsWorkData
     * @summary Создать импорт (WorkDataImport)
     * @request POST:/imports/workData
     * @secure
     */
    postImportsWorkData: (
      data: WorkDataImportDto,
      params: RequestParams = {},
    ) =>
      this.request<ImportDto, UserErrorMessage>({
        path: `/imports/workData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список всех существующих импортов по указанным id (@Viewer)
     *
     * @tags Imports
     * @name PostImportsFindByIds
     * @summary Найти импорты по id
     * @request POST:/imports/findByIds
     * @secure
     */
    postImportsFindByIds: (data: string[], params: RequestParams = {}) =>
      this.request<ImportDto[], UserErrorMessage>({
        path: `/imports/findByIds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Загрузка документа (excel) с заявками на исполнение (@Manager)
     *
     * @tags Imports
     * @name PostImportsExcelSr
     * @summary Загрузка заявок
     * @request POST:/imports/excel/sr
     * @secure
     */
    postImportsExcelSr: (
      query: {
        /**
         * ID контракта
         * @format int64
         */
        contractId: number;
        /** Тип документа */
        docType?:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
        /** Схема импорта данных в систему */
        loadType: "REGISTRY" | "WORKER" | "THIRD_SIDE";
        /** Комментарий */
        comment: string;
        /** Тип услуги */
        deviceType: string;
      },
      data: {
        /**
         * Документ excel для загрузки в SR
         * @format binary
         */
        docFile?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/imports/excel/sr`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Загрузка документа (excel) с устройствами для заявок (@Manager)
     *
     * @tags Imports
     * @name PostImportsExcelDevices
     * @summary Загрузка устройств
     * @request POST:/imports/excel/devices
     * @secure
     */
    postImportsExcelDevices: (
      data: {
        /**
         * Таблица для загрузки в справочник устройств
         * @format binary
         */
        docFile: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/imports/excel/devices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Установка статуса 'APPROVED' через загрузку закрывающего Excel-документа (@Manager)
     *
     * @tags Imports
     * @name PostImportsExcelApprove
     * @summary Загрузка статусов
     * @request POST:/imports/excel/approve
     * @secure
     */
    postImportsExcelApprove: (
      data: {
        /**
         * Документ для загрузки в справочник устройств
         * @format binary
         */
        docFile?: File;
      },
      query?: {
        /** Комментарий */
        comment?: string;
        /**
         * ID контракта
         * @format int64
         */
        contractId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/imports/excel/approve`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список существующих импортов по фильтру (@Viewer)
     *
     * @tags Imports
     * @name GetImportsFilter
     * @summary Получить список импортов по фильтру
     * @request GET:/imports/filter
     * @secure
     */
    getImportsFilter: (
      query?: {
        /**
         * contract ID
         * @format int64
         */
        contractId?: number;
        /**
         * Статусы
         * @uniqueItems true
         */
        statuses?: (
          | "WAITING_FOR_START"
          | "PROCESSING"
          | "FINISHED_SUCCESSFULLY"
          | "FINISHED_WITH_ERRORS"
          | "REJECTED"
        )[];
        /** Тип документа */
        docType?:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageImportDto, UserErrorMessage>({
        path: `/imports/filter`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  filtersSets = {
    /**
     * @description Получить все фильтры (@Viewer)
     *
     * @tags Filters sets
     * @name GetFiltersSets
     * @summary Найти фильтры
     * @request GET:/filtersSets
     * @secure
     */
    getFiltersSets: (
      query?: {
        /** Name */
        name?: string;
        /** Filter type */
        filterType?: string;
        /**
         * User Uid
         * @format uuid
         */
        userUid?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageFiltersSetDto, UserErrorMessage>({
        path: `/filtersSets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующий фильтр пользователя (@Worker)
     *
     * @tags Filters sets
     * @name PutFiltersSets
     * @summary Обновить фильтр
     * @request PUT:/filtersSets
     * @secure
     */
    putFiltersSets: (data: FiltersSetDto, params: RequestParams = {}) =>
      this.request<FiltersSetDto, UserErrorMessage>({
        path: `/filtersSets`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Завести новый фильтр пользователя (@Worker)
     *
     * @tags Filters sets
     * @name PostFiltersSets
     * @summary Создать фильтр
     * @request POST:/filtersSets
     * @secure
     */
    postFiltersSets: (data: FiltersSetDto, params: RequestParams = {}) =>
      this.request<FiltersSetDto, UserErrorMessage>({
        path: `/filtersSets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить существующие фильтры по id (@Worker)
     *
     * @tags Filters sets
     * @name DeleteFiltersSets
     * @summary Удалить фильтр(ы)
     * @request DELETE:/filtersSets
     * @secure
     */
    deleteFiltersSets: (data: number[], params: RequestParams = {}) =>
      this.request<number[], UserErrorMessage>({
        path: `/filtersSets`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить все фильтры по списку id (@Viewer)
     *
     * @tags Filters sets
     * @name PostFiltersSetsFindByIDs
     * @summary Найти по списку ID
     * @request POST:/filtersSets/findByIDs
     * @secure
     */
    postFiltersSetsFindByIDs: (data: number[], params: RequestParams = {}) =>
      this.request<FiltersSetDto[], UserErrorMessage>({
        path: `/filtersSets/findByIDs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  documents = {
    /**
     * @description Заменить старый файл другим (перезалить) (@Worker)
     *
     * @tags Documents
     * @name PutDocumentsReplaceDocId
     * @summary Обновление документа
     * @request PUT:/documents/replace/{docId}
     * @secure
     */
    putDocumentsReplaceDocId: (
      docId: string,
      query: {
        /**
         * ID заявки
         * @format int64
         */
        srId: number;
        /** Комментарий к файлу */
        description: string;
      },
      data: {
        /**
         * Документ
         * @format binary
         */
        docFile?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/documents/replace/${docId}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Добавить/Обновить комментарий к существующему файлу (@Manager)
     *
     * @tags Documents
     * @name PostDocumentsDocIdComment
     * @summary Добавить/Обновить комментарий
     * @request POST:/documents/{docId}/comment
     * @secure
     */
    postDocumentsDocIdComment: (
      docId: string,
      query?: {
        /**
         * Для идемпотентности запроса
         * @format uuid
         */
        offlineRequestId?: string;
        /** Комментарий */
        comment?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/documents/${docId}/comment`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Детектор размытости входящего изображения (@Worker)
     *
     * @tags Documents
     * @name PostDocumentsHardness
     * @summary Определение качества фото
     * @request POST:/documents/hardness
     * @secure
     */
    postDocumentsHardness: (
      data: {
        /**
         * Изображение для анализа чёткости
         * @format binary
         */
        image?: File;
      },
      query?: {
        /**
         * Увеличить допуск на Х
         * @format int32
         * @default 10
         */
        rise?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        "RESTRICTED" | "BLURRED" | "LOWQ" | "MED" | "NORMAL" | "NONE",
        UserErrorMessage
      >({
        path: `/documents/hardness`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить модель документа по его ID (@Viewer)
     *
     * @tags Documents
     * @name GetDocumentsDocId
     * @summary Получить модель документа
     * @request GET:/documents/{docId}
     * @secure
     */
    getDocumentsDocId: (docId: string, params: RequestParams = {}) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/documents/${docId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить существующий документ (из заявки с указанным id) (@Manager)
     *
     * @tags Documents
     * @name DeleteDocumentsDocId
     * @summary Удалить документ
     * @request DELETE:/documents/{docId}
     * @secure
     */
    deleteDocumentsDocId: (
      docId: string,
      query: {
        /**
         * ID заявки
         * @format int64
         */
        srId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/documents/${docId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить контент файла по его uid (@Worker)
     *
     * @tags Documents
     * @name GetDocumentsDocIdContent
     * @summary Получить загруженный ранее файл (контент)
     * @request GET:/documents/{docId}/content
     * @secure
     */
    getDocumentsDocIdContent: (docId: string, params: RequestParams = {}) =>
      this.request<void, UserErrorMessage>({
        path: `/documents/${docId}/content`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Возвращает ZIP с документами указанной заявки (@Viewer)
     *
     * @tags Documents
     * @name GetDocumentsImages
     * @summary Получить ZIP с документами заявки
     * @request GET:/documents/images
     * @secure
     */
    getDocumentsImages: (
      query: {
        /**
         * ID заявки
         * @format int64
         */
        srId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<StreamingResponseBody, UserErrorMessage>({
        path: `/documents/images`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dicts = {
    /**
     * @description Получить список всех причин отмены заявок (@Viewer)
     *
     * @tags Rejection reasons
     * @name GetDictsSrRejections
     * @summary Список причин отмены
     * @request GET:/dicts/sr/rejections
     * @secure
     */
    getDictsSrRejections: (
      query?: {
        /** code */
        code?: string;
        /** name */
        name?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageReasonRejectionDictDto, UserErrorMessage>({
        path: `/dicts/sr/rejections`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующую причину отмены заявок (@Manager)
     *
     * @tags Rejection reasons
     * @name PutDictsSrRejections
     * @summary Обновить причину отмены
     * @request PUT:/dicts/sr/rejections
     * @secure
     */
    putDictsSrRejections: (
      data: ReasonRejectionDictDto,
      params: RequestParams = {},
    ) =>
      this.request<ReasonRejectionDictDto, UserErrorMessage>({
        path: `/dicts/sr/rejections`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новую причину отмены заявок (@Manager)
     *
     * @tags Rejection reasons
     * @name PostDictsSrRejections
     * @summary Зарегистрировать причину отмены
     * @request POST:/dicts/sr/rejections
     * @secure
     */
    postDictsSrRejections: (
      data: ReasonRejectionDictDto,
      params: RequestParams = {},
    ) =>
      this.request<ReasonRejectionDictDto, UserErrorMessage>({
        path: `/dicts/sr/rejections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список всех существующих услуг (@Viewer)
     *
     * @tags Service Types
     * @name GetDictsServiceTypes
     * @summary Список услуг
     * @request GET:/dicts/service/types
     * @secure
     */
    getDictsServiceTypes: (
      query?: {
        /** code */
        code?: string;
        /** name */
        name?: string;
        /** uiName */
        uiName?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageServiceTypesDictDto, UserErrorMessage>({
        path: `/dicts/service/types`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующий тип услуги (@Manager)
     *
     * @tags Service Types
     * @name PutDictsServiceTypes
     * @summary Обновить услугу
     * @request PUT:/dicts/service/types
     * @secure
     */
    putDictsServiceTypes: (
      data: ServiceTypesDictDto,
      params: RequestParams = {},
    ) =>
      this.request<ServiceTypesDictDto, UserErrorMessage>({
        path: `/dicts/service/types`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новый тип услуги (@Manager)
     *
     * @tags Service Types
     * @name PostDictsServiceTypes
     * @summary Завести услугу
     * @request POST:/dicts/service/types
     * @secure
     */
    postDictsServiceTypes: (
      data: ServiceTypesDictDto,
      params: RequestParams = {},
    ) =>
      this.request<ServiceTypesDictDto, UserErrorMessage>({
        path: `/dicts/service/types`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список всех типов мест проведения работ (@Viewer)
     *
     * @tags Contract locations
     * @name GetDictsContractLocations
     * @summary Поиск мест проведения работ
     * @request GET:/dicts/contract/locations
     * @secure
     */
    getDictsContractLocations: (
      query?: {
        /** code */
        code?: string;
        /** name */
        name?: string;
        /**
         * aliases
         * @uniqueItems true
         */
        aliases?: string[];
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageContractLocationsDictDto, UserErrorMessage>({
        path: `/dicts/contract/locations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующее место проведения работ (@Manager)
     *
     * @tags Contract locations
     * @name PutDictsContractLocations
     * @summary Обновить место проведения работ
     * @request PUT:/dicts/contract/locations
     * @secure
     */
    putDictsContractLocations: (
      data: ContractLocationsDictDto,
      params: RequestParams = {},
    ) =>
      this.request<ContractLocationsDictDto, UserErrorMessage>({
        path: `/dicts/contract/locations`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новое место проведения работ (@Manager)
     *
     * @tags Contract locations
     * @name PostDictsContractLocations
     * @summary Завести место проведения работ
     * @request POST:/dicts/contract/locations
     * @secure
     */
    postDictsContractLocations: (
      data: ContractLocationsDictDto,
      params: RequestParams = {},
    ) =>
      this.request<ContractLocationsDictDto, UserErrorMessage>({
        path: `/dicts/contract/locations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти причину отмены заявки по названию (@Viewer)
     *
     * @tags Rejection reasons
     * @name GetDictsSrRejectionsCode
     * @summary Найти причину отмены
     * @request GET:/dicts/sr/rejections/{code}
     * @secure
     */
    getDictsSrRejectionsCode: (code: string, params: RequestParams = {}) =>
      this.request<ReasonRejectionDictDto, UserErrorMessage>({
        path: `/dicts/sr/rejections/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти услугу по названию (@Viewer)
     *
     * @tags Service Types
     * @name GetDictsServiceTypesCode
     * @summary Поиск услуги
     * @request GET:/dicts/service/types/{code}
     * @secure
     */
    getDictsServiceTypesCode: (code: string, params: RequestParams = {}) =>
      this.request<ServiceTypesDictDto, UserErrorMessage>({
        path: `/dicts/service/types/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список всех доступных статусов по типу услуг (@Viewer)
     *
     * @tags Service Types
     * @name GetDictsServiceTypesStatuses
     * @summary Список статусов по услугам
     * @request GET:/dicts/service/types/statuses
     * @secure
     */
    getDictsServiceTypesStatuses: (
      query?: {
        /** Тип услуги (либо null, если нужен полный справочник) */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SRStatus[], UserErrorMessage>({
        path: `/dicts/service/types/statuses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список всех уникальных услуг моих контрактов (@Viewer)
     *
     * @tags Service Types
     * @name GetDictsServiceTypesMy
     * @summary Получить мои услуги
     * @request GET:/dicts/service/types/my
     * @secure
     */
    getDictsServiceTypesMy: (params: RequestParams = {}) =>
      this.request<ServiceTypesDictDto[], UserErrorMessage>({
        path: `/dicts/service/types/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти место проведения работ по его названию (@Viewer)
     *
     * @tags Contract locations
     * @name GetDictsContractLocationsCode
     * @summary Поиск места проведения работ
     * @request GET:/dicts/contract/locations/{code}
     * @secure
     */
    getDictsContractLocationsCode: (code: string, params: RequestParams = {}) =>
      this.request<ContractLocationsDictDto, UserErrorMessage>({
        path: `/dicts/contract/locations/${code}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  devices = {
    /**
     * @description Поиск оборудования по критериям (@Worker)
     *
     * @tags Devices
     * @name GetDevices
     * @summary Поиск оборудования
     * @request GET:/devices
     * @secure
     */
    getDevices: (
      query?: {
        /**
         * ID оборудования
         * @format int64
         */
        id?: number;
        /** Serial number оборудования */
        serial?: string;
        /** Operator оборудования */
        operator?: string;
        /** Имя модели оборудования */
        modelName?: string;
        /**
         * год производства оборудования
         * @format int32
         */
        createdYear?: number;
        /** Статус оборудования */
        status?:
          | "UNKNOWN"
          | "FREE"
          | "BROKEN"
          | "RETIREMENT"
          | "ISSUED"
          | "INSTALLED";
        /** Требуется модерация? */
        isModerationNeeds?: boolean;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageDeviceDictionaryDto, UserErrorMessage>({
        path: `/devices`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменение данных существующего устройства (@Manager)
     *
     * @tags Devices
     * @name PutDevices
     * @summary Обновить устройство
     * @request PUT:/devices
     * @secure
     */
    putDevices: (data: DeviceDictionaryDto, params: RequestParams = {}) =>
      this.request<DeviceDictionaryDto, UserErrorMessage>({
        path: `/devices`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Переключить флаг устройства isModerationNeeds на false (@Manager)
     *
     * @tags Devices
     * @name GetDevicesVerify
     * @summary Выключить флаг модерации
     * @request GET:/devices/verify
     * @secure
     */
    getDevicesVerify: (
      query: {
        /**
         * ID устройства
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/devices/verify`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  delayReasons = {
    /**
     * @description Найти причину задержки по id (@Viewer)
     *
     * @tags Delay reasons
     * @name GetDelayReasonsRsnId
     * @summary Найти причину задержки
     * @request GET:/delayReasons/{rsnId}
     * @secure
     */
    getDelayReasonsRsnId: (rsnId: number, params: RequestParams = {}) =>
      this.request<ReasonDelayDto, UserErrorMessage>({
        path: `/delayReasons/${rsnId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Доступно частичное обновление - передавать можно только необходимые для изменения поля (@Manager)
     *
     * @tags Delay reasons
     * @name PutDelayReasonsRsnId
     * @summary Изменение причины задержки
     * @request PUT:/delayReasons/{rsnId}
     * @secure
     */
    putDelayReasonsRsnId: (
      rsnId: number,
      data: {
        /**
         * Документ
         * @format binary
         */
        docFile?: File;
        /**
         * Дополнительный документ
         * @format binary
         */
        docFile2?: File;
      },
      query?: {
        /**
         * Для идемпотентности запроса
         * @format uuid
         */
        offlineRequestId?: string;
        /**
         * Дата задержки
         * @format date-time
         */
        date?: string;
        /** Комментарий */
        comment?: string;
        /** Тип документа */
        docType?:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
        /** Тип документа */
        docType2?:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
      },
      params: RequestParams = {},
    ) =>
      this.request<ReasonDelayDto, UserErrorMessage>({
        path: `/delayReasons/${rsnId}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Доступно при статусах: READY_TO_PROCESS, DELAYED.Производит смену статуса в DELAYED. Увеличивает счетчик reasonDelayCount в serviceRequest. Для ролей: WORKER, MANAGER (@Worker)
     *
     * @tags Delay reasons
     * @name PostDelayReasonsSrId
     * @summary Добавление причины задержки
     * @request POST:/delayReasons/{srId}
     * @secure
     */
    postDelayReasonsSrId: (
      srId: number,
      query: {
        /**
         * Для идемпотентности запроса
         * @format uuid
         */
        offlineRequestId?: string;
        /** Тип документа */
        docType:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
        /**
         * Дата задержки
         * @format date-time
         */
        date?: string;
        /** Комментарий */
        comment?: string;
        /** Тип документа */
        docType2?:
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER";
      },
      data: {
        /**
         * Документ
         * @format binary
         */
        docFile: File;
        /**
         * Дополнительный документ
         * @format binary
         */
        docFile2?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReasonDelayDto, UserErrorMessage>({
        path: `/delayReasons/${srId}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Формируется в хронологическом порядке (@Viewer)
     *
     * @tags Delay reasons
     * @name GetDelayReasons
     * @summary Получить причины задержки указанной заявки
     * @request GET:/delayReasons
     * @secure
     */
    getDelayReasons: (
      query: {
        /** @format int64 */
        srId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReasonDelayDto[], UserErrorMessage>({
        path: `/delayReasons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contracts = {
    /**
     * @description Получить постраничный список всех доступных по companyId контрактов (@ManagerOrCustomer)
     *
     * @tags Contracts
     * @name GetContracts
     * @summary Получить страницу контрактов
     * @request GET:/contracts
     * @secure
     */
    getContracts: (
      query?: {
        /** Статус обработки контракта */
        status?: "IMPORTING" | "IMPORTED" | "PROCESSING" | "CREATED" | "DONE";
        /**
         * uid компании данного контракта
         * @format uuid
         */
        companyId?: string;
        /**
         * Порядковый номер контракта
         * @format int64
         */
        counter?: number;
        /** Название компании, заключившей контракт */
        companyName?: string;
        /** Идентификатор по договору */
        contractNumber?: string;
        /** Тип устройств данного контракта */
        serviceType?: string;
        /**
         * Дата начала контракта
         * @format date-time
         */
        startDate?: string;
        /**
         * Дата истечения контракта
         * @format date-time
         */
        dueDate?: string;
        /**
         * Со статусом архивных?
         * @default false
         */
        archive?: boolean;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageContractDto, UserErrorMessage>({
        path: `/contracts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующий контракт (@Manager)
     *
     * @tags Contracts
     * @name PutContracts
     * @summary Обновить контракт
     * @request PUT:/contracts
     * @secure
     */
    putContracts: (
      query: {
        /** UUID менеджеров в данном контракте */
        managers: string[];
      },
      data: ContractDto,
      params: RequestParams = {},
    ) =>
      this.request<ContractDto, UserErrorMessage>({
        path: `/contracts`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новый контракт (@ProjectManager)
     *
     * @tags Contracts
     * @name PostContracts
     * @summary Создать контракт
     * @request POST:/contracts
     * @secure
     */
    postContracts: (
      data: ContractDto,
      query?: {
        /** UUID менеджеров для прикрепления к новому контракту */
        managers?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractDto, UserErrorMessage>({
        path: `/contracts`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить данные указанного документа контракта (@Manager)
     *
     * @tags Contracts
     * @name PutContractsCidDocumentUpdate
     * @summary Обновить данные документа
     * @request PUT:/contracts/{cid}/document/update
     * @secure
     */
    putContractsCidDocumentUpdate: (
      cid: number,
      query: {
        /**
         * ID документа
         * @format uuid
         */
        docId: string;
        /** Новое имя документа */
        newName?: string;
        /** Новое описание документа */
        newDescription?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractDto, UserErrorMessage>({
        path: `/contracts/${cid}/document/update`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти все документы указанного контракта (@Viewer)
     *
     * @tags Contracts
     * @name GetContractsCidDocuments
     * @summary Найти документы контракта
     * @request GET:/contracts/{cid}/documents
     * @secure
     */
    getContractsCidDocuments: (
      cid: number,
      query: {
        pageable: Pageable;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageDocumentDto, UserErrorMessage>({
        path: `/contracts/${cid}/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Загрузка документов (изображений) на back-end (@Manager)
     *
     * @tags Contracts
     * @name PostContractsCidDocuments
     * @summary Загрузка документов на бэк
     * @request POST:/contracts/{cid}/documents
     * @secure
     */
    postContractsCidDocuments: (
      cid: number,
      query: {
        docTypes?: (
          | "SERVICE_REQUESTS"
          | "DICTIONARY_UPDATE"
          | "STATUS_APPROVED_UPDATE"
          | "SERVICE_REQUESTS_IMPORT_ERROR_DOC"
          | "SERVICE_REQUESTS_REASON_DELAY_DOC"
          | "OUT_REPORT"
          | "SERVICE_REQUESTS_PHOTO"
          | "OTHER"
        )[];
        description: string;
      },
      data: {
        docFiles?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, UserErrorMessage>({
        path: `/contracts/${cid}/documents`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Получить список контрактов по указанным id (@Viewer)
     *
     * @tags Contracts
     * @name PostContractsFindByIDs
     * @summary Получить контракты по списку
     * @request POST:/contracts/findByIDs
     * @secure
     */
    postContractsFindByIDs: (data: number[], params: RequestParams = {}) =>
      this.request<ContractDto[], UserErrorMessage>({
        path: `/contracts/findByIDs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Заархивировать контракт (@Manager)
     *
     * @tags Contracts
     * @name PostContractsArchive
     * @summary Управление архивацией
     * @request POST:/contracts/archive
     * @secure
     */
    postContractsArchive: (
      query: {
        /**
         * id контракта
         * @format int64
         */
        contractId: number;
        /** Сделать ли архивным? */
        isArchived: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/contracts/archive`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить список всех моих контрактов (@Viewer)
     *
     * @tags Contracts
     * @name GetContractsMy
     * @summary Получить мои контракты
     * @request GET:/contracts/my
     * @secure
     */
    getContractsMy: (params: RequestParams = {}) =>
      this.request<ContractDto[], UserErrorMessage>({
        path: `/contracts/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить указанный документ контракта (@Manager)
     *
     * @tags Contracts
     * @name DeleteContractsCidDocumentsDocumentId
     * @summary Удалить документ контракта
     * @request DELETE:/contracts/{cid}/documents/{documentId}
     * @secure
     */
    deleteContractsCidDocumentsDocumentId: (
      cid: number,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/contracts/${cid}/documents/${documentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  brigades = {
    /**
     * @description Получить список бригад по фильтрам (@Viewer)
     *
     * @tags Brigades
     * @name GetBrigades
     * @summary Найти все бригады
     * @request GET:/brigades
     * @secure
     */
    getBrigades: (
      query?: {
        /**
         * Коллекция UID бригад
         * @uniqueItems true
         */
        ids?: string[];
        /** Имя бригады */
        name?: string;
        /** Описание бригады */
        description?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageBrigadeGroupDto, UserErrorMessage>({
        path: `/brigades`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить существующую бригаду (@Manager)
     *
     * @tags Brigades
     * @name PutBrigades
     * @summary Обновить бригаду
     * @request PUT:/brigades
     * @secure
     */
    putBrigades: (data: BrigadeGroupDto, params: RequestParams = {}) =>
      this.request<BrigadeGroupDto, UserErrorMessage>({
        path: `/brigades`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новую бригаду (@Manager)
     *
     * @tags Brigades
     * @name PostBrigades
     * @summary Создать бригаду
     * @request POST:/brigades
     * @secure
     */
    postBrigades: (data: BrigadeGroupDto, params: RequestParams = {}) =>
      this.request<BrigadeGroupDto, UserErrorMessage>({
        path: `/brigades`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти состоящих в указанной бригаде (@Viewer)
     *
     * @tags Brigades
     * @name GetBrigadesBidUsers
     * @summary Получить членов бригады
     * @request GET:/brigades/{bid}/users
     * @secure
     */
    getBrigadesBidUsers: (bid: string, params: RequestParams = {}) =>
      this.request<UserAccountDto[], UserErrorMessage>({
        path: `/brigades/${bid}/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Добавить в бригаду указанных людей (@Manager)
     *
     * @tags Brigades
     * @name PutBrigadesBidUsers
     * @summary Добавить членов бригады
     * @request PUT:/brigades/{bid}/users
     * @secure
     */
    putBrigadesBidUsers: (
      bid: string,
      query: {
        accountUids: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UserAccountDto[], UserErrorMessage>({
        path: `/brigades/${bid}/users`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Переписать членов указанной бригады новым списком (@Manager)
     *
     * @tags Brigades
     * @name PostBrigadesBidUsers
     * @summary Заменить состав бригады
     * @request POST:/brigades/{bid}/users
     * @secure
     */
    postBrigadesBidUsers: (
      bid: string,
      query: {
        accountUids: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UserAccountDto[], UserErrorMessage>({
        path: `/brigades/${bid}/users`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти бригаду, в которой я лидер (@Viewer)
     *
     * @tags Brigades
     * @name GetBrigadesMy
     * @summary Получить подопечную бригаду
     * @request GET:/brigades/my
     * @secure
     */
    getBrigadesMy: (params: RequestParams = {}) =>
      this.request<BrigadeGroupDto[], UserErrorMessage>({
        path: `/brigades/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  address = {
    /**
     * @description Получить все части адресов по фильтру (@Viewer)
     *
     * @tags Address-items
     * @name GetAddress
     * @summary Получить все части
     * @request GET:/address
     * @secure
     */
    getAddress: (
      query?: {
        /** Текстовое представление (улица Красная, город Ростов и т.п.) */
        name?: string;
        /** Тип составной части адреса */
        itemType?: "DISTRICT" | "REGION" | "CITY" | "STREET";
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageAddressItemDto, UserErrorMessage>({
        path: `/address`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменить существующую часть адреса (@Manager)
     *
     * @tags Address-items
     * @name PutAddress
     * @summary Обновить часть
     * @request PUT:/address
     * @secure
     */
    putAddress: (data: AddressItemDto, params: RequestParams = {}) =>
      this.request<AddressItemDto, UserErrorMessage>({
        path: `/address`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать новую часть адреса (@Manager)
     *
     * @tags Address-items
     * @name PostAddress
     * @summary Завести новую часть
     * @request POST:/address
     * @secure
     */
    postAddress: (data: AddressItemDto, params: RequestParams = {}) =>
      this.request<AddressItemDto, UserErrorMessage>({
        path: `/address`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти полный адрес по входящему примеру (@Manager)
     *
     * @tags Addresses
     * @name PostAddressFindExample
     * @summary Получить полный адрес
     * @request POST:/address/find/example
     * @secure
     */
    postAddressFindExample: (
      data: FullAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<FullAddressDto[], UserErrorMessage>({
        path: `/address/find/example`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  accounts = {
    /**
     * @description Получить список пользователей по фильтру (@Viewer)
     *
     * @tags UserAccounts
     * @name GetAccounts
     * @summary Найти пользователей
     * @request GET:/accounts
     * @secure
     */
    getAccounts: (
      query?: {
        /** Логин пользователя */
        userLogin?: string;
        /** ФИО пользователя */
        fio?: string;
        /** email пользователя */
        email?: string;
        /**
         * Uid компании пользователя
         * @format uuid
         */
        companyId?: string;
        /**
         * Роли пользователя
         * @uniqueItems true
         */
        roles?: (
          | "ROLE_ANONYMOUS"
          | "ROLE_VIEWER"
          | "ROLE_CUSTOMER"
          | "ROLE_WORKER"
          | "ROLE_MANAGER"
          | "ROLE_PROJECT_MANAGER"
          | "ROLE_DIRECTOR"
          | "ROLE_FUNCTIONAL_ADMIN"
          | "ROLE_OWNER"
          | "ROLE_ADMIN"
          | "ROLE_DEVELOPER"
          | "ROLE_FRONTEND"
        )[];
        /** Активна ли запись пользователя? */
        isActive?: boolean;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageUserAccountDto, UserErrorMessage>({
        path: `/accounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Изменить фио, email или телефон пользователя (@FunctionalAdmin)
     *
     * @tags UserAccounts
     * @name PutAccounts
     * @summary Обновить пользователя
     * @request PUT:/accounts
     * @secure
     */
    putAccounts: (data: UserAccountDto, params: RequestParams = {}) =>
      this.request<UserAccountDto, UserErrorMessage>({
        path: `/accounts`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description  (@FunctionalAdmin)
     *
     * @tags UserAccounts
     * @name PostAccounts
     * @summary Создать пользователя
     * @request POST:/accounts
     * @secure
     */
    postAccounts: (data: UserAccountDto, params: RequestParams = {}) =>
      this.request<UserAccountDto, UserErrorMessage>({
        path: `/accounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Активировать или деактивировать пользователя (@Manager)
     *
     * @tags UserAccounts
     * @name PutAccountsUidBlock
     * @summary Выключатель пользователя
     * @request PUT:/accounts/{uid}/block
     * @secure
     */
    putAccountsUidBlock: (
      uid: string,
      query: {
        /** Блокировать или разблокировать пользователя? */
        isBlock: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/accounts/${uid}/block`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Замена старого пароля пользователя временным (@Manager)
     *
     * @tags UserAccounts
     * @name PutAccountsChangePassword
     * @summary Сброс пароля пользователя
     * @request PUT:/accounts/changePassword
     * @secure
     */
    putAccountsChangePassword: (
      data: ChangedPasswordRecord,
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/accounts/changePassword`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти пользователей по id (@Viewer)
     *
     * @tags UserAccounts
     * @name PostAccountsFindByUids
     * @summary Найти пользователей
     * @request POST:/accounts/findByUids
     * @secure
     */
    postAccountsFindByUids: (data: string[], params: RequestParams = {}) =>
      this.request<UserAccountDto[], UserErrorMessage>({
        path: `/accounts/findByUids`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти пользователя по его логину (@Viewer)
     *
     * @tags UserAccounts
     * @name PostAccountsFindByLogin
     * @summary Поиск пользователя по логину
     * @request POST:/accounts/findByLogin
     * @secure
     */
    postAccountsFindByLogin: (
      query: {
        /** Логин пользователя */
        login: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserAccountDto, UserErrorMessage>({
        path: `/accounts/findByLogin`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccounts
     * @name GetAccountsMe
     * @request GET:/accounts/me
     * @secure
     */
    getAccountsMe: (params: RequestParams = {}) =>
      this.request<UserAccountDto, UserErrorMessage>({
        path: `/accounts/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти пользователей по ролям и группам (@Viewer)
     *
     * @tags UserAccounts
     * @name GetAccountsFindByGroups
     * @summary Найти пользователей
     * @request GET:/accounts/findByGroups
     * @secure
     */
    getAccountsFindByGroups: (
      query?: {
        /** Роли пользователей */
        role?:
          | "ROLE_ANONYMOUS"
          | "ROLE_VIEWER"
          | "ROLE_CUSTOMER"
          | "ROLE_WORKER"
          | "ROLE_MANAGER"
          | "ROLE_PROJECT_MANAGER"
          | "ROLE_DIRECTOR"
          | "ROLE_FUNCTIONAL_ADMIN"
          | "ROLE_OWNER"
          | "ROLE_ADMIN"
          | "ROLE_DEVELOPER"
          | "ROLE_FRONTEND";
        /**
         * inGroups
         * @uniqueItems true
         */
        inGroups?: number[];
        /**
         * exGroups
         * @uniqueItems true
         */
        exGroups?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UserAccountDto[], UserErrorMessage>({
        path: `/accounts/findByGroups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  workStages = {
    /**
     * @description Получить все шаги исполнения заявок (@Worker)
     *
     * @tags Work stages
     * @name GetWorkStages
     * @summary Получить все шаги
     * @request GET:/workStages
     * @secure
     */
    getWorkStages: (
      query?: {
        /** Имя шага заполнения заявки */
        name?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageWorkStageDto, UserErrorMessage>({
        path: `/workStages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Завести новый или обновить существующий шаг исполнения заявок (@FunctionalAdmin)
     *
     * @tags Work stages
     * @name PostWorkStages
     * @summary Создать или обновить шаг
     * @request POST:/workStages
     * @secure
     */
    postWorkStages: (data: WorkStageDto, params: RequestParams = {}) =>
      this.request<WorkStageDto, UserErrorMessage>({
        path: `/workStages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращается доступный исполнителю контент, структурировано в виде дерева, при наличии контента в структуре заполняется свойство 'item' (@Worker)
     *
     * @tags Work stages
     * @name GetWorkStagesIdContentTree
     * @summary Получить контент структурировано
     * @request GET:/workStages/{id}/contentTree
     * @secure
     */
    getWorkStagesIdContentTree: (id: number, params: RequestParams = {}) =>
      this.request<WorkStageFullDto[], UserErrorMessage>({
        path: `/workStages/${id}/contentTree`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * @description Получить список шаблонов отчётов по фильтрам (@Viewer)
     *
     * @tags Reports
     * @name GetReports
     * @summary Список шаблонов отчётов
     * @request GET:/reports
     * @secure
     */
    getReports: (
      query?: {
        /**
         * Report ID
         * @format int64
         */
        id?: number;
        /** Report name */
        name?: string;
        /** Description */
        description?: string;
        /**
         * Показать только свои или шаблоны компании?
         * @default true
         */
        myOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportTemplateRecord[], UserErrorMessage>({
        path: `/reports`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Сохранить/обновить шаблон динамического отчёта (@Manager)
     *
     * @tags Reports
     * @name PostReports
     * @summary Сохранить/обновить шаблон
     * @request POST:/reports
     * @secure
     */
    postReports: (data: ReportTemplateRecord, params: RequestParams = {}) =>
      this.request<ReportTemplateRecord, UserErrorMessage>({
        path: `/reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить шаблон отчёта по его id (@Manager)
     *
     * @tags Reports
     * @name DeleteReports
     * @summary Удалить шаблон отчёта
     * @request DELETE:/reports
     * @secure
     */
    deleteReports: (
      query: {
        /**
         * ID отчёта
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        UserErrorMessage
      >({
        path: `/reports`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  export = {
    /**
     * @description Получить отчёт по истории заявок (@Viewer)
     *
     * @tags Exports
     * @name PostExportReport
     * @summary Получить отчёт (HistoryReport)
     * @request POST:/export/report
     * @secure
     */
    postExportReport: (
      query: {
        /** @format date-time */
        beginDate: string;
        /** @format date-time */
        endDate: string;
        /** @uniqueItems true */
        statuses?: string[];
        /**
         * Порядковый номер контракта заявки
         * @format int64
         * @example 1
         */
        counter?: number;
        /**
         * Тип устройства
         * @example "ELECTRICITY_METER | CHARGING_STATION"
         */
        deviceType?: string;
        /**
         * ID бригады работника
         * @format uuid
         * @example "90e4dece-b832-4a23-be95-a1c9bd40c2f6"
         */
        workerGroupId?: string;
        /**
         * ID менеджера
         * @format uuid
         */
        managerId?: string;
        /**
         * ID работника
         * @format uuid
         */
        workerId?: string;
        /**
         * Тип места проведения работ
         * @example "APARTMENT"
         */
        taskLocationCode?: string;
        /**
         * Количество задержек
         * @format int32
         * @example 3
         */
        reasonDelayCount?: number;
        /**
         * (проблема с поиском по БД)
         * @example "Выборгское"
         */
        district?: string;
        /**
         * Район, регион, область
         * @example "Ленинградская область"
         */
        region?: string;
        /**
         * Населённый пункт
         * @example "г Выборг"
         */
        city?: string;
        /**
         * Улица
         * @example "ш Ленинградское"
         */
        street?: string;
        /**
         * Номер дома
         * @example 99
         */
        house?: string;
        /**
         * Квартира
         * @example 38
         */
        apartment?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/export/report`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить отчёт по ID шаблона отчёта (@Viewer)
     *
     * @tags Exports
     * @name PostExportReportUniversal
     * @summary Получить отчёт по шаблону
     * @request POST:/export/report/universal
     * @secure
     */
    postExportReportUniversal: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/export/report/universal`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить отчёт по ??? (@Viewer)
     *
     * @tags Exports
     * @name PostExportMasterCounterReport
     * @summary Получить отчёт (CounterReport)
     * @request POST:/export/masterCounterReport
     * @secure
     */
    postExportMasterCounterReport: (params: RequestParams = {}) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/export/masterCounterReport`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить отчёт по задержкам выполнения заявок (@Viewer)
     *
     * @tags Exports
     * @name PostExportDelayReport
     * @summary Получить отчёт (DelayReport)
     * @request POST:/export/delayReport
     * @secure
     */
    postExportDelayReport: (params: RequestParams = {}) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/export/delayReport`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить отчёт по ??? (@Viewer)
     *
     * @tags Exports
     * @name PostExportCurrentStateReport
     * @summary Получить отчёт (StateReport)
     * @request POST:/export/currentStateReport
     * @secure
     */
    postExportCurrentStateReport: (
      query?: {
        /** Коллекция статусов */
        statuses?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/export/currentStateReport`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить JSON схему отчёта (@Viewer)
     *
     * @tags Exports
     * @name GetExportReportUniversalModel
     * @summary Получить JSON схему отчёта
     * @request GET:/export/report/universalModel
     * @secure
     */
    getExportReportUniversalModel: (params: RequestParams = {}) =>
      this.request<JsonNode, UserErrorMessage>({
        path: `/export/report/universalModel`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить универсальный отчёт по id (@Viewer)
     *
     * @tags Exports
     * @name GetExportReportGetByIDs
     * @summary Получить универсальный отчёт (UniversalReport)
     * @request GET:/export/report/getByIDs
     * @secure
     */
    getExportReportGetByIDs: (
      query: {
        /**
         * ID шаблона отчета
         * @format int64
         */
        id: number;
        /**
         * Тип услуги
         * @format int64
         */
        serviceTypeId?: number;
        /**
         * Если дата не передана, то начальная дата не ограничена
         * @format date-time
         */
        beginDate?: string;
        /**
         * Если дата не передана, то конечная дата не ограничена
         * @format date-time
         */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, UserErrorMessage>({
        path: `/export/report/getByIDs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  companies = {
    /**
     * @description Получение страниц всех компаний (@Viewer)
     *
     * @tags Companies
     * @name GetCompanies
     * @summary Все компании
     * @request GET:/companies
     * @secure
     */
    getCompanies: (
      query?: {
        /** Название компании */
        name?: string;
        /** Searching key word */
        keyWord?: string;
        /** ИНН */
        inn?: string;
        /** ОГРН */
        ogrn?: string;
        /** Описание */
        description?: string;
        /**
         * Исходный companyId (плюс дочерние)
         * @format uuid
         */
        companyId?: string;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 10
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageCompanyDto, UserErrorMessage>({
        path: `/companies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание и обновление компании (@ProjectManager)
     *
     * @tags Companies
     * @name PostCompanies
     * @summary Создать/обновить компанию
     * @request POST:/companies
     * @secure
     */
    postCompanies: (data: CompanyDto, params: RequestParams = {}) =>
      this.request<CompanyDto, UserErrorMessage>({
        path: `/companies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение компаний по id (@Viewer)
     *
     * @tags Companies
     * @name PostCompaniesFindByIDs
     * @summary Найти компании
     * @request POST:/companies/findByIDs
     * @secure
     */
    postCompaniesFindByIDs: (data: string[], params: RequestParams = {}) =>
      this.request<CompanyDto[], UserErrorMessage>({
        path: `/companies/findByIDs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Для получения демонстрационного доступа к системе (@Anonymous)
     *
     * @tags Companies
     * @name PostCompaniesCreateForDemo
     * @summary Демо доступ
     * @request POST:/companies/createForDemo
     */
    postCompaniesCreateForDemo: (
      query: {
        /** Наименование компании */
        fullCompanyName: string;
        /** ИНН компании */
        inn: string;
        /** Телефон компании */
        phone: string;
        /** Электронная почта компании */
        email: string;
        /** Веб-сайт компании */
        website?: string;
        /**
         * UID проверяемой капчи
         * @format uuid
         */
        captchaId?: string;
        /** Расшифровка капчи */
        captcha?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompanyDto, UserErrorMessage>({
        path: `/companies/createForDemo`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка людей, привязанных к данной компании (@Viewer)
     *
     * @tags Companies
     * @name GetCompaniesCidPersons
     * @summary Члены компании
     * @request GET:/companies/{cid}/persons
     * @secure
     */
    getCompaniesCidPersons: (cid: string, params: RequestParams = {}) =>
      this.request<PersonDto[], UserErrorMessage>({
        path: `/companies/${cid}/persons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает ZIP с документами компании (@Customer)
     *
     * @tags Companies
     * @name GetCompaniesDocumentsLoad
     * @summary ZIP с документами заявок по ИНН компании
     * @request GET:/companies/documents/load
     * @secure
     */
    getCompaniesDocumentsLoad: (
      query: {
        /**
         * ИНН компании
         * @example 3328424479
         */
        companyInn: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format int32 */
          nameCount?: number;
          fileSystem?: {
            rootDirectories?: object;
            fileStores?: object;
            userPrincipalLookupService?: object;
            separator?: string;
            readOnly?: boolean;
            open?: boolean;
          };
          absolute?: boolean;
        },
        UserErrorMessage
      >({
        path: `/companies/documents/load`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  billing = {
    /**
     * @description Список всех, существующих тарифов (@Viewer)
     *
     * @tags Tariffs
     * @name GetBillingTariffs
     * @summary Получение тарифов
     * @request GET:/billing/tariffs
     * @secure
     */
    getBillingTariffs: (params: RequestParams = {}) =>
      this.request<RawTariffDto[], UserErrorMessage>({
        path: `/billing/tariffs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Установить указанный тариф указанной компании (@Admin)
     *
     * @tags Tariffs
     * @name PostBillingTariffs
     * @summary Установить тариф
     * @request POST:/billing/tariffs
     * @secure
     */
    postBillingTariffs: (
      query: {
        /**
         * ID компании
         * @format uuid
         */
        companyId: string;
        /**
         * ID Тарифа
         * @format int64
         */
        tariffId: number;
        /**
         * ID Длительности тарифа
         * @format int64
         */
        durationId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, UserErrorMessage>({
        path: `/billing/tariffs`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Найти тариф по фильтру (id, title, etc) (@Viewer)
     *
     * @tags Tariffs
     * @name GetBillingTariffsFilter
     * @summary Поиск тарифа
     * @request GET:/billing/tariffs/filter
     * @secure
     */
    getBillingTariffsFilter: (
      query?: {
        /**
         * ID тарифа
         * @format int64
         */
        id?: number;
        /** Название тарифа */
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RawTariffDto, UserErrorMessage>({
        path: `/billing/tariffs/filter`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dashboard = {
    /**
     * @description Аналитическая сводка по заявкам
     *
     * @tags Dashboard
     * @name GetDashboard
     * @request GET:/dashboard
     * @secure
     */
    getDashboard: (
      query?: {
        /** Тип услуги */
        serviceType?: string;
        /** Статус заявок */
        status?: string;
        /**
         * Период выборки данных для дашборда
         * @default "ALL"
         * @example "ALL"
         */
        period?: "WEEK" | "MONTH" | "QUARTER" | "YEAR" | "ALL";
        /**
         * Ручной выбор (от)
         * @format date-time
         */
        from?: string;
        /**
         * Ручной выбор (до)
         * @format date-time
         */
        to?: string;
        /** Вместе с архивными */
        isArchive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardDto, UserErrorMessage>({
        path: `/dashboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка заявок для дашборда 2
     *
     * @tags Dashboard
     * @name GetDashboardServiceRequests
     * @request GET:/dashboard/serviceRequests
     * @secure
     */
    getDashboardServiceRequests: (
      query: {
        /**
         * Тип услуги
         * @example "ELECTRICITY_METER"
         */
        serviceType: string;
        /**
         * Период выборки данных для дашборда
         * @default "WEEK"
         * @example "WEEK"
         */
        period?: "WEEK" | "MONTH" | "QUARTER" | "YEAR" | "ALL";
        /**
         * Ручной выбор (от)
         * @format date-time
         */
        from?: string;
        /**
         * Ручной выбор (до)
         * @format date-time
         */
        to?: string;
        /**
         * ID заявки
         * @format int64
         */
        id?: number;
        /**
         * Порядковый номер
         * @format int64
         */
        counter?: number;
        /** Статус заявки */
        status?: string;
        /**
         * ID контракта
         * @format int64
         */
        contractId?: number;
        /** Номер контракта */
        contractNumber?: string;
        /** Лицевой счёт */
        extNumber?: string;
        /** Район */
        district?: string;
        /** Регион, область, край */
        region?: string;
        /** Населённый пункт */
        city?: string;
        /** Улица */
        street?: string;
        /** Полный адрес */
        fullAddress?: string;
        /** Номер дома */
        house?: string;
        /** Квартира */
        apartment?: string;
        /** Тип устройства */
        deviceTypeCode?: string;
        /** Номер устройства (старого) */
        deviceNumberOld?: string;
        /** Номер устройства (нового) */
        deviceNumberNew?: string;
        /**
         * ID менеджера
         * @format uuid
         */
        managerId?: string;
        /**
         * ID работника
         * @format uuid
         */
        workerId?: string;
        /**
         * ID бригады работника
         * @format uuid
         */
        workerGroupId?: string;
        /** Тип расположения */
        contractLocation?: string;
        /**
         * Количество задержек
         * @format int32
         */
        reasonDelayCount?: number;
        /** Вместе с архивными */
        isArchive?: boolean;
        /**
         * Страница
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Записей на страницу
         * @format int32
         * @min 1
         * @default 5
         */
        size?: number;
        /** Сортировка */
        order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageDashboardDtoPaged, UserErrorMessage>({
        path: `/dashboard/serviceRequests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  captcha = {
    /**
     * @description Получить капчу (PNG) по указанному captchaId (или сам captchaId новой капчи)
     *
     * @tags Tests
     * @name GetCaptcha
     * @request GET:/captcha
     * @secure
     */
    getCaptcha: (
      query?: {
        /**
         * UID капчи (null для генерации нового)
         * @format uuid
         */
        captchaId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<JsonNode, UserErrorMessage>({
        path: `/captcha`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
